import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: { // teste 
      // App Name
      appName: "Emaar Platform",
      
      // Navigation
      dashboard: "Dashboard",
      proDashboard: "Pro Dashboard",
      analytics: "Analytics",
      rooms: "Rooms",
      bookings: "Bookings",
      userManagement: "User Management",
      reviews: "Reviews",
      coupons: "Coupons & Promotions",
      support: "Support",
      reports: "Reports",
      notifications: "Notifications",
      staticContent: "Static Content",
      profileSettings: "Profile Settings",
      settings: "Settings",
      guests: "Guests",
      housekeeping: "Housekeeping",
      maintenance: "Maintenance",
      users: "Users",
      products: "Product Manage",
      categories: "Categories Manage",
      brands: "Brands Manage",
      orders: "Orders Manage",
      collapseSidebar: "Collapse sidebar",
      expandSidebar: "Expand sidebar",
      
      // User Management
      manageUsers: "Manage system users and their permissions",
      addUser: "Add User",
      createUser: "Create New User",
      createUserDescription: "Add a new user to the system",
      editUser: "Edit User",
      updateUserInformation: "Update user information",
      viewUserDetails: "View User Details",
      userDetails: "User Details",
      viewUserInformation: "View detailed user information",
      deleteUser: "Delete User",
      confirmDeleteUser: "Are you sure you want to delete this user?",
      userDeleted: "User deleted successfully",
      userUpdated: "User updated successfully",
      userCreated: "User created successfully",
      failedToDeleteUser: "Failed to delete user",
      failedToUpdateUser: "Failed to update user",
      failedToCreateUser: "Failed to create user",
      
      // User Form Fields
      name: "Name",
      email: "Email",
      phone: "Phone",
      password: "Password",
      role: "Role",
      status: "Status",
      language: "Language",
      registrationDate: "Registration Date",
      lastLogin: "Last Login",
      enterName: "Enter full name",
      enterEmail: "Enter email address",
      enterPhone: "Enter phone number",
      enterPassword: "Enter password",
      selectRole: "Select role",
      selectLanguage: "Select language",
      
      // User Roles
      customer: "Customer",
      staff: "Staff",
      admin: "Admin",
      superAdmin: "Super Admin",
      
      // User Status
      active: "Active",
      inactive: "Inactive",
      suspended: "Suspended",
      deleted: "Deleted",
      blocked: "Blocked",
      
      // User Actions
      block: "Block",
      activate: "Activate",
      deactivate: "Deactivate",
      resetPassword: "Reset Password",
      passwordResetEmailSent: "Password reset email sent",
      failedToResetPassword: "Failed to reset password",
      userStatusUpdated: "User status updated successfully",
      failedToUpdateUserStatus: "Failed to update user status",
      failedToRequestPasswordReset: "Failed to request password reset",
      sendOTP: "Send OTP",
      otp: "OTP",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      enterOTP: "Enter OTP",
      enterNewPassword: "Enter new password",
      confirmNewPassword: "Confirm new password",
      passwordsDoNotMatch: "Passwords do not match",
      pleaseEnterOTP: "Please enter OTP",
      pleaseEnterPasswordAndConfirmation: "Please enter new password and confirmation",
      otpSentVia: "OTP sent via",
      forTestingPurposes: "for testing purposes",
      otpWillBeSent: "An OTP will be sent to",
      viaSMS: "via SMS",
      requestOTPToResetPassword: "Request OTP to reset password for",
      enterOTPAndNewPassword: "Enter OTP and new password for",
      id: "ID",
      passwordResetSuccessful: "Password reset successful",
      passwordTooShort: "Password must be at least 8 characters",
      
      // Categories
      categoriesManage: "Categories Manage",
      totalCategories: "Total Categories",
      activeCategories: "Active Categories",
      inactiveCategories: "Inactive Categories",
      searchCategories: "Search Categories",
      searchCategoriesPlaceholder: "Search by name...",
      categoryName: "Name",
      categoryNameAr: "Name (AR)",
      categoryIcon: "Icon",
      addCategory: "Add Category",
      editCategory: "Edit Category",
      deleteCategory: "Delete Category",
      categoryCreated: "Category created successfully",
      categoryUpdated: "Category updated successfully",
      categoryDeleted: "Category deleted successfully",
      noCategoriesFound: "No categories found",
      categoriesSelected: "categories selected",
      organizeProductsCategories: "Organize your products into categories",
      categoryDetails: "Category Details",
      viewCategoryInformation: "View detailed category information",
      viewCategory: "View Category",
      updateCategoryInformation: "Update category information",
      enterCategoryName: "Enter category name",
      enterCategoryNameAr: "Enter category name in Arabic",
      enterIcon: "Enter icon name",
      confirmDeleteCategory: "Are you sure you want to delete this category?",
      failedToUpdateCategory: "Failed to update category",
      failedToDeleteCategory: "Failed to delete category",
      productName: "Product Name",
      stock: "Stock",
      updatedAt: "Updated At",
      
      // Brands
      brandsManage: "Brands Manage",
      totalBrands: "Total Brands",
      activeBrands: "Active Brands",
      inactiveBrands: "Inactive Brands",
      searchBrands: "Search Brands",
      searchBrandsPlaceholder: "Search by name...",
      brandName: "Name",
      brandNameAr: "Name (AR)",
      brandLogo: "Logo",
      brandLogoUrl: "Logo URL",
      addBrand: "Add Brand",
      createBrand: "Create Brand",
      createNewBrand: "Create a new brand",
      editBrand: "Edit Brand",
      deleteBrand: "Delete Brand",
      brandCreated: "Brand created successfully",
      brandUpdated: "Brand updated successfully",
      brandDeleted: "Brand deleted successfully",
      noBrandsFound: "No brands found",
      brandsSelected: "brands selected",
      manageBrands: "Manage product brands",
      brandDetails: "Brand Details",
      viewBrandInformation: "View detailed brand information",
      viewBrand: "View Brand",
      updateBrandInformation: "Update brand information",
      enterBrandName: "Enter brand name",
      enterBrandNameAr: "Enter brand name in Arabic",
      enterLogoUrl: "Enter logo URL",
      confirmDeleteBrand: "Are you sure you want to delete this brand?",
      failedToCreateBrand: "Failed to create brand",
      failedToUpdateBrand: "Failed to update brand",
      failedToDeleteBrand: "Failed to delete brand",
      
      // Products
      productsManage: "Products Manage",
      manageProducts: "Manage your products",
      addProduct: "Add Product",
      searchProductsPlaceholder: "Search by name, SKU...",
      noProductsFound: "No products found",
      productDetails: "Product Details",
      viewProductInformation: "View detailed product information",
      viewProduct: "View Product",
      editProduct: "Edit Product",
      deleteProduct: "Delete Product",
      productName: "Name",
      sku: "SKU",
      barcode: "Barcode",
      price: "Price",
      currency: "SDG",
      description: "Description",
      productImages: "Product Images",
      rating: "Rating",
      featured: "Featured",
      sortBy: "Sort By",
      selectSort: "Select Sort",
      newest: "Newest",
      popular: "Popular",
      priceLowToHigh: "Price: Low to High",
      priceHighToLow: "Price: High to Low",
      selectCategory: "Select Category",
      allCategories: "All Categories",
      selectBrand: "Select Brand",
      allBrands: "All Brands",
      
      // Product Create/Edit
      createNewProduct: "Create a new product",
      updateProductInformation: "Update product information",
      productCreated: "Product created successfully",
      productUpdated: "Product updated successfully",
      failedToCreateProduct: "Failed to create product",
      failedToUpdateProduct: "Failed to update product",
      enterProductName: "Enter product name",
      enterProductNameAr: "Enter product name in Arabic",
      productNameAr: "Name (AR)",
      descriptionAr: "Description (AR)",
      discountPrice: "Discount Price",
      enterSku: "Enter SKU",
      enterBarcode: "Enter barcode",
      enterDescription: "Enter description",
      enterDescriptionAr: "Enter description in Arabic",
      thumbnailUrl: "Thumbnail URL",
      enterThumbnailUrl: "Enter thumbnail URL",
      addImage: "Add Image",
      enterImageUrl: "Enter image URL",
      creating: "Creating...",
      pleaseCompleteAllRequiredFields: "Please complete all required fields",
      productDeleted: "Product deleted successfully",
      failedToDeleteProduct: "Failed to delete product",
      confirmDeleteProduct: "Are you sure you want to delete this product?",
      productStatusUpdated: "Product status updated successfully",
      failedToUpdateProductStatus: "Failed to update product status",
      productStockUpdated: "Product stock updated successfully",
      failedToUpdateProductStock: "Failed to update product stock",
      updateStock: "Update Stock",
      updateProductStock: "Update the stock quantity for this product",
      pleaseEnterValidStock: "Please enter a valid stock number",
      
      // User Statistics
      totalUsers: "Total Users",
      activeUsers: "Active Users",
      blockedUsers: "Blocked Users",
      adminUsers: "Admin Users",
      
      // User Table
      contact: "Contact",
      actions: "Actions",
      view: "View",
      edit: "Edit",
      delete: "Delete",
      openMenu: "Open menu",
      
      // User Search & Filters
      search: "Search",
      searchUsers: "Search by name, phone, or email",
      searchUsersPlaceholder: "Search by name, email, or phone...",
      filterByRole: "Filter by role",
      filterByStatus: "Filter by status",
      searchAndFilters: "Search and Filters",
      allRoles: "All Roles",
      allStatuses: "All Statuses",
      selectStatus: "Select Status",
      pageSize: "Items per page",
      refresh: "Refresh",
      usersSelected: "users selected",
      saveScreenshot: "Save Screenshot",
      screenshotSaved: "Screenshot saved successfully",
      savingScreenshot: "Saving screenshot...",
      failedToSaveScreenshot: "Failed to save screenshot",
      
      // User Bulk Actions
      selectedUsersCount: "{{count}} users selected",
      clearSelection: "Clear Selection",
      bulkActions: "Bulk Actions",
      bulkActivate: "Activate Selected",
      bulkBlock: "Block Selected",
      bulkDelete: "Delete Selected",
      bulkOperationCompleted: "Bulk operation completed",
      bulkOperationFailed: "Bulk operation failed",
      noUsersSelected: "No Users Selected",
      pleaseSelectUsers: "Please select users to perform bulk actions",
      
      // User Export/Import
      export: "Export",
      exportCSV: "Export as CSV",
      exportExcel: "Export as Excel",
      exportStarted: "Export Started",
      downloadWillStartShortly: "Download will start shortly",
      exportFailed: "Export failed",
      
      // User Pagination
      showing: "Showing",
      of: "of",
      previous: "Previous",
      next: "Next",
      
      // User Validation
      validationError: "Validation Error",
      pleaseCompleteAllFields: "Please complete all required fields",
      noChanges: "No Changes",
      noChangesToSave: "No changes to save",
      
      // General
      success: "Success",
      error: "Error",
      loading: "Loading",
      cancel: "Cancel",
      save: "Save",
      saveChanges: "Save Changes",
      creating: "Creating",
      saving: "Saving",
      close: "Close",
      never: "Never",
      unknown: "Unknown",
      noUsersFound: "No users found",
      
      // Property Types Management
      propertyTypes: "Property Types",
      managePropertyTypes: "Manage different types of properties in the system",
      addPropertyType: "Add Property Type",
      createPropertyType: "Create Property Type",
      createPropertyTypeDescription: "Add a new property type to the system",
      editPropertyType: "Edit Property Type",
      updatePropertyTypeInformation: "Update property type information",
      propertyTypeDetails: "Property Type Details",
      viewPropertyTypeInformation: "View detailed property type information",
      deletePropertyType: "Delete Property Type",
      propertyTypeCreated: "Property type created successfully",
      propertyTypeUpdated: "Property type updated successfully",
      propertyTypeDeleted: "Property type deleted successfully",
      propertyTypeStatusUpdated: "Property type status updated",
      failedToCreatePropertyType: "Failed to create property type",
      failedToUpdatePropertyType: "Failed to update property type",
      failedToDeletePropertyType: "Failed to delete property type",
      failedToUpdateStatus: "Failed to update status",
      
      // Property Type Fields
      nameEnglish: "Name (English)",
      nameArabic: "Name (Arabic)",
      descriptionEnglish: "Description (English)",
      descriptionArabic: "Description (Arabic)",
      enterDescriptionEnglish: "Enter description in English",
      enterDescriptionArabic: "Enter description in Arabic",
      icon: "Icon",
      selectIcon: "Select icon",
      
      // Property Type Statistics
      totalTypes: "Total Types",
      activeTypes: "Active Types",
      inactiveTypes: "Inactive Types",
      
      // Property Type Actions
      deactivate: "Deactivate",
      bulkDeactivate: "Deactivate Selected",
      noPropertyTypesFound: "No property types found",
      searchPropertyTypes: "Search property types...",
      typesSelected: "types selected",
      noTypesSelected: "No Types Selected",
      pleaseSelectTypes: "Please select property types",
      
      // Property Type Status & Dates
      created: "Created",
      lastUpdated: "Last Updated",
      
      reviews: "Reviews",
      reviewsManagement: "Reviews Management",
      manageHotelReviewsAndRatings: "Manage hotel reviews and ratings",
      addReview: "Add Review",
      addNewReview: "Add New Review",
      createNewReviewForHotel: "Create a new review for a hotel.",
      averageRating: "Average Rating",
      acrossAllReviews: "Across all reviews",
      approvedReviews: "Approved Reviews",
      pendingReviews: "Pending Reviews",
      awaitingApproval: "Awaiting approval",
      allReviews: "All Reviews",
      searchReviews: "Search reviews...",
      editReview: "Edit Review",
      updateReviewInformationAndStatus: "Update review information and status.",
      user: "User",
      rating: "Rating",
      title: "Title",
      helpful: "Helpful",
      date: "Date",
      approved: "Approved",
      pending: "Pending",
      rejected: "Rejected",
      hotelName: "Hotel Name",
      userName: "User Name",
      reviewTitle: "Review Title",
      reviewComment: "Review Comment",
      hotelResponse: "Hotel Response",
      optionalHotelResponse: "Optional hotel response...",
      createReview: "Create Review",
      updateReview: "Update Review",
      reviewCreatedSuccessfully: "Review created successfully",
      reviewUpdatedSuccessfully: "Review updated successfully",
      failedToCreateReview: "Failed to create review",
      failedToUpdateReview: "Failed to update review",

      deleteReview: "Delete Review",
      confirmDeleteReview: "Are you sure you want to delete this review? This action cannot be undone.",
      reviewDeleted: "Review deleted successfully",
      failedToDeleteReview: "Failed to delete review",
      viewReview: "View Review",
      reviewDetails: "Review Details",
      reviewInformation: "Review Information",
      reviewResponse: "Review Response",
      helpfulVotes: "Helpful Votes",
      notHelpfulVotes: "Not Helpful Votes",
      totalVotes: "Total Votes",
      reviewStatus: "Review Status",
      reviewDate: "Review Date",
      noReviewsFound: "No reviews found",
      failedToLoadReviews: "Failed to load reviews",
      star: "Star",
      stars: "Stars",
      payments: "Payments",
      support: "Support",
      revenue: "Revenue",
      settings: "Settings",
      logout: "Logout",

      // User Roles
      customer: "Customer",
      admin: "Admin",
      staff: "Staff",
      user: "User",

      // Extended Navigation
      analytics: "Analytics",
      drivers: "Drivers",
      riders: "Riders",
      vehicles: "Vehicles",
      trips: "Trips",
      complaints: "Complaints",
      cities: "Cities",
      notifications: "Notifications",
      guests: "Guests",
      housekeeping: "Housekeeping",

      // Additional Common
      approve: "Approve",
      reject: "Reject",
      yes: "Yes",
      no: "No",
      confirm: "Confirm",
      send: "Send",
      schedule: "Schedule",
      notFound: "Page not found",

      // Login & Authentication
      signIn: "Sign In",
      phoneNumber: "Phone Number",
      saudiPhoneFormat: "Saudi phone format: +966XXXXXXXXX",
      password: "Password",
      enterPassword: "Enter your password",
      loginSuccessful: "Login Successful",
      loginFailed: "Login Failed",
      invalidCredentials: "Invalid credentials",
      validationError: "Validation Error",
      phoneAndPasswordRequired: "Phone and password are required",
      loading: "Loading...",

      // Dashboard
      totalHotels: "Partner Hotels",
      activeHotels: "Active Hotels",
      todayBookings: "Today's Bookings",
      monthlyRevenue: "Monthly Revenue",
      availableRooms: "Available Rooms",
      weeklyRevenue: "Weekly Revenue",
      dailyRevenue: "Daily Revenue",
      
      // Quick Actions
      addNewRoom: "Add New Room",
      manageCoupons: "Manage Coupons",
      checkReviews: "Check Reviews",
      quickActions: "Quick Actions",
      
      // Charts
      bookingTrends: "Booking Trends",
      paymentMethods: "Payment Methods",
      occupancyByRoomType: "Occupancy by Room Type",
      weeklyBookings: "Weekly Bookings",
      dailyBookings: "Daily Bookings",
      revenueDistribution: "Revenue Distribution",
      
      // Activity Feed
      bookingCancellation: "Booking Cancellation",
      roomAdded: "Room Added",
      
      // Notifications
      lowAvailability: "Low Availability",
      systemAlert: "System Alert",
      onlyRoomsLeft: "Only {{count}} {{type}} Room(s) left for {{date}}",
      reviewsAwaitingApproval: "{{count}} reviews awaiting approval",
      paymentGatewayError: "Payment gateway error detected",
      apiIssue: "API connectivity issue",
      
      // Dashboard specific text
      overview: "Overview",
      overviewHotelManagement: "Overview of your hotel management platform performance",
      roomsAvailable: "rooms available",
      newReservationsToday: "new reservations today",
      fromLastMonth: "from last month",
      newReservations: "new reservations",
      fromLastWeek: "from last week",
      fromYesterday: "from yesterday",
      fromLastMonthRating: "from last month",
      
      // Room types
      deluxe: "Deluxe",
      standard: "Standard",
      family: "Family",
      
      // Activity messages
      newBookingDeluxe: "New booking for Deluxe Room",
      newReviewSubmitted: "New review submitted by Ahmed Al-Rashid",
      paymentReceived: "Payment received for Booking #1234",
      bookingCancelled: "Booking #1230 cancelled",
      couponUsed: "Coupon 'SUMMER20' used",
      minutesAgo: "minutes ago",
      hoursAgo: "hours ago",
      
      // Notification messages
      onlyDeluxeRoomLeft: "Only 1 Deluxe Room left for Sept 5th",
      reviewsAwaitingApprovalCount: "3 reviews awaiting approval",
      paymentGatewayRestored: "Payment gateway connection restored",

      // Common
      hotel: "Hotel",
      search: "Search",
      filter: "Filter",
      status: "Status",
      actions: "Actions",
      edit: "Edit",
      delete: "Delete",
      view: "View",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      noData: "No data available",

      // Auth
      welcome: "Welcome",
      welcomeToBadeelAlawal: "Welcome to Emaar Platform!",

      // Bookings
      bookingManagement: "Booking Management",
      addBooking: "Add Booking",
      editBooking: "Edit Booking",
      createBooking: "Create Booking",
      bookingDetails: "Booking Details",
      allBookings: "All Bookings",
      newUser: "New User",
      existingUser: "Existing User",
      userName: "User Name",
      userPhone: "User Phone",
      enterUserName: "Enter user name",
      enterUserPhone: "Enter phone number",
      pleaseFillUserFields: "Please fill in user name and phone number",
      phoneRequiredWhenNoUser: "Phone is required when no user is selected",
      pleaseSelectUser: "Please select a user",
      creatingUser: "Creating user account...",
      userCreatedSuccessfully: "User account created successfully",
      failedToCreateUser: "Failed to create user account",
      paymentPageOpened: "Payment page opened in new window",
      popupBlocked: "Popup blocked. Please allow popups",
      verifyingPayment: "Verifying payment...",
      paymentSuccessful: "Payment Successful",
      paymentFailed: "Payment Failed",
      paymentVerifiedSuccessfully: "Payment verified successfully",
      paymentVerificationFailed: "Payment verification failed",
      missingPaymentParameters: "Missing payment parameters",
      redirectingToBookings: "Redirecting to bookings page...",
      goToBookings: "Go to Bookings",
      smsSentTo: "SMS sent to",
      smsNotSent: "SMS was not sent. Please check SMS settings",
      smsSentToCustomerCompletePayment: "SMS sent to customer, please complete payment process",
      manageHotelReservationsAndBookings: "Manage hotel reservations and bookings",
      createNewHotelReservation: "Create a new hotel reservation",
      viewBookingInformation: "View booking information",
      bookingCreatedSuccessfully: "Booking created successfully",
      bookingCancelledSuccessfully: "Booking cancelled successfully",
      failedToCreateBooking: "Failed to create booking",
      failedToCancelBooking: "Failed to cancel booking",
      failedToDeleteBooking: "Failed to delete booking",
      bookingDeletedSuccessfully: "Booking deleted successfully",
      confirmDeleteBooking: "Are you sure you want to delete this booking? This action cannot be undone.",
      refund: "Refund",
      enterRefundReason: "Enter refund reason:",
      confirmRefundBooking: "Are you sure you want to refund this booking?",
      bookingRefundedSuccessfully: "Booking refunded successfully",
      failedToRefundBooking: "Failed to refund booking",
      failedToLoadBookings: "Failed to load bookings",
      failedToLoadBookingDetails: "Failed to load booking details",
      failedToExportBookings: "Failed to export bookings",
      bookingsExportedSuccessfully: "Bookings exported successfully",
      paymentPending: "Payment Pending",
      propertyInformation: "Property Information",
      financialDetails: "Financial Details",
      bookingMetadata: "Booking Metadata",
      additionalInformation: "Additional Information",
      couponApplied: "Coupon Applied",
      bookingStatus: "Booking Status",
      bookingDates: "Booking Dates",
      originalAmount: "Original Amount",
      discountAmount: "Discount Amount",
      finalAmount: "Final Amount",
      depositAmount: "Deposit Amount",
      depositPaid: "Deposit Paid",
      remainingAmount: "Remaining Amount",
      specialRequests: "Special Requests",
      notes: "Notes",
      userId: "User ID",
      propertyId: "Property ID",
      createdAt: "Created At",
      lastUpdated: "Last Updated",
      paymentReference: "Payment Reference",
      bookingNotFound: "Booking Not Found",
      guests: "Guests",
      selectReason: "Select Reason",
      payment: "Payment",
      twilioProvider: "Twilio",
      unifonicProvider: "Unifonic", 
      checkConsoleForDetails: "Check console for details",
      currentRole: "Current Role",
      filterByUser: "Filter by User",
      filterByProperty: "Filter by Property",
      changeStatus: "Change Status",
      changeBookingStatus: "Change Booking Status",
      changeBookingStatusDescription: "Select the new status for this booking. This action cannot be undone.",
      currentStatus: "Current Status",
      newStatus: "New Status",
      selectNewStatus: "Select New Status",
      cancellationReason: "Cancellation Reason",
      customReason: "Custom Reason",
      enterCustomReason: "Enter custom reason",
      cancelReasonRequired: "Cancellation reason is required",
      bookingStatusUpdated: "Booking status updated successfully",
      failedToUpdateBookingStatus: "Failed to update booking status",
      customerRequest: "Customer Request",
      propertyUnavailable: "Property Unavailable",
      emergency: "Emergency",
      paymentFailed: "Payment Failed",
      maintenance: "Maintenance",
      other: "Other",
      updating: "Updating...",
      updateStatus: "Update Status",
      cancelBooking: "Cancel Booking",
      creating: "Creating...",
      bookingId: "Booking ID",
      property: "Property",
      checkInDate: "Check In Date",
      checkOutDate: "Check Out Date",
      guestCount: "Guest Count",
      paymentMethod: "Payment Method",
      couponCode: "Coupon Code",
      enterCouponCode: "Enter coupon code",
      specialRequests: "Special Requests",
      enterSpecialRequests: "Enter special requests",
      paymentSummary: "Payment Summary",
      totalAmount: "Total Amount",
      depositRequired: "Deposit Required",
      remainingAmount: "Remaining Amount",
      depositPercentage: "Deposit: {{percentage}}%",
      depositNote: "A 30% deposit is required at booking time, the remaining amount will be paid upon check-in.",
      depositExplanation: "Deposit is required for all bookings regardless of coupons. This secures your reservation.",
      noDepositNote: "Full payment is required at booking time. No deposit needed.",
      couponDiscount: "Coupon Discount",
      selectProperty: "Select Property",
      selectStatus: "Select Status",
      selectPaymentMethod: "Select Payment Method",
      searchPaymentMethods: "Search payment methods",
      failedToLoadPaymentMethods: "Failed to load payment methods",
      noPaymentMethods: "No payment methods available",
      usingMockPaymentMethods: "Using mock payment methods",
      canceled: "Canceled",
      completed: "Completed",
      dateFrom: "Date From",
      dateTo: "Date To",
      clearFilters: "Clear Filters",
      exportCSV: "Export CSV",
      exportExcel: "Export Excel",
      searchBookings: "Search bookings...",
      filters: "Filters",
      createdOn: "Created on",
      bookingInformation: "Booking Information",
      paymentInformation: "Payment Information",
      customerInformation: "Customer Information",
      depositPaid: "Deposit Paid",
      customerName: "Customer Name",
      customerEmail: "Customer Email",
      customerPhone: "Customer Phone",
      createNewUserAccount: "Create a new user account.",
      updateUserInformationAndStatus: "Update user information and status.",
      viewUserInformation: "View user information.",
      customerLanguage: "Customer Language",
      pastBookings: "Past Bookings",
      customerAverageRating: "Customer Average Rating",
      couponUsedStatus: "Coupon Used",
      confirmedBookings: "Confirmed Bookings",
      allTimeBookings: "All time bookings",
      activeReservations: "Active reservations",
      fromAllBookings: "From all bookings",
      pendingDeposits: "Pending Deposits",
      awaitingPayment: "Awaiting payment",
      bookingNotFound: "Booking not found",

      // Hotels

      // Payments
      paymentManagement: "Payment Management",

      // Users
      addUser: "Add User",
      editUser: "Edit User",
      deleteUser: "Delete User",
      viewUser: "View User",
      userDetails: "User Details",
      createUser: "Create User",
      updateUser: "Update User",
      userCreatedSuccessfully: "User created successfully",
      userUpdatedSuccessfully: "User updated successfully",
      userDeletedSuccessfully: "User deleted successfully",
      failedToCreateUser: "Failed to create user",
      failedToUpdateUser: "Failed to update user",
      failedToDeleteUser: "Failed to delete user",
      confirmDeleteUser: "Are you sure you want to delete this user? This action cannot be undone.",
      userNotFound: "User not found",
      activeUsers: "Active Users",
      inactiveUsers: "Inactive Users",
      suspendedUsers: "Suspended Users",
      newUsers: "New Users",
      userRole: "User Role",
      userStatus: "User Status",
      joinDate: "Join Date",
      lastLogin: "Last Login",
      regular: "Regular",
      userAvatar: "User Avatar",
      userProfile: "User Profile",
      userActivity: "User Activity",
      userPermissions: "User Permissions",
      userSettings: "User Settings",
      filterByRole: "Filter by role",
      filterByStatus: "Filter by status",
      allRoles: "All Roles",
      userStatistics: "User Statistics",
      userAnalytics: "User Analytics",
      userReports: "User Reports",
      exportUsers: "Export Users",
      importUsers: "Import Users",
      bulkActions: "Bulk Actions",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      bulkDelete: "Bulk Delete",
      bulkUpdate: "Bulk Update",
      userGroups: "User Groups",
      userCategories: "User Categories",
      userTags: "User Tags",
      userNotes: "User Notes",
      userComments: "User Comments",
      userHistory: "User History",
      userLogs: "User Logs",
      userAudit: "User Audit",
      
      // Status Values
      
      // Static Content Management
      staticContentManagement: "Static Content Management",
      manageStaticContent: "Manage Static Content",
      staticcontent: "Static Pages & Information",
      aboutUsPage: "About Us Page",
      contactInformation: "Contact Information",
      galleryPhotos: "Gallery Photos",
      legalPages: "Legal Pages",
      privacyPolicy: "Privacy Policy",
      termsConditions: "Terms & Conditions",
      contentPreview: "Content Preview",
      richTextEditor: "Rich Text Editor",
      uploadPhotos: "Upload Photos",
      editContent: "Edit Content",
      saveChanges: "Save Changes",
      publishChanges: "Publish Changes",
      previewChanges: "Preview Changes",
      versionHistory: "Version History",
      contentVersioning: "Content Versioning",
      livePreview: "Live Preview",
      mobilePreview: "Mobile Preview",
      printPreview: "Print Preview",
      bilingualSupport: "Bilingual Support",
      rtlSupport: "RTL Support",
      ltrSupport: "LTR Support",
      
      // Content Management Actions
      addNewContent: "Add New Content",
      deleteContent: "Delete Content",
      duplicateContent: "Duplicate Content",
      moveContent: "Move Content",
      copyContent: "Copy Content",
      archiveContent: "Archive Content",
      restoreContent: "Restore Content",
      publishContent: "Publish Content",
      unpublishContent: "Unpublish Content",
      schedulePublish: "Schedule Publish",
      contentStatus: "Content Status",
      draft: "Draft",
      published: "Published",
      archived: "Archived",
      
      // Rich Text Editor
      bold: "Bold",
      italic: "Italic",
      underline: "Underline",
      strikethrough: "Strikethrough",
      alignLeft: "Align Left",
      alignCenter: "Align Center",
      alignRight: "Align Right",
      alignJustify: "Justify",
      insertLink: "Insert Link",
      insertImage: "Insert Image",
      insertList: "Insert List",
      insertOrderedList: "Insert Ordered List",
      insertUnorderedList: "Insert Unordered List",
      undo: "Undo",
      redo: "Redo",
      clearFormatting: "Clear Formatting",
      textColor: "Text Color",
      backgroundColor: "Background Color",
      fontSize: "Font Size",
      fontFamily: "Font Family",
      
      // Contact Information
      emailAddress: "Email Address",
      whatsappNumber: "WhatsApp Number",
      physicalAddress: "Physical Address",
      socialMedia: "Social Media",
      website: "Website",
      businessHours: "Business Hours",
      contactType: "Contact Type",
      contactValue: "Contact Value",
      contactLabel: "Contact Label",
      displayOrder: "Display Order",
      isActive: "Is Active",
      addContactInfo: "Add Contact Information",
      editContactInfo: "Edit Contact Information",
      deleteContactInfo: "Delete Contact Information",
      
      // Gallery Management
      imageUpload: "Image Upload",
      dragDropImages: "Drag & Drop Images Here",
      selectImages: "Select Images",
      imageMetadata: "Image Metadata",
      altText: "Alt Text",
      imageCaption: "Image Caption",
      imageCategory: "Image Category",
      imageTags: "Image Tags",
      imageSize: "Image Size",
      imageFormat: "Image Format",
      imageDimensions: "Image Dimensions",
      uploadProgress: "Upload Progress",
      uploadComplete: "Upload Complete",
      uploadFailed: "Upload Failed",
      maxFileSize: "Max File Size",
      allowedFormats: "Allowed Formats",
      imageOptimization: "Image Optimization",
      thumbnailGeneration: "Thumbnail Generation",
      imageCompression: "Image Compression",
      
      // Content Types
      textContent: "Text Content",
      htmlContent: "HTML Content",
      markdownContent: "Markdown Content",
      plainText: "Plain Text",
      formattedText: "Formatted Text",
      mediaContent: "Media Content",
      embeddedContent: "Embedded Content",
      dynamicContent: "Dynamic Content",
      staticContent: "Static Content",
      
      // Validation Messages
      contentRequired: "Content is required",
      titleRequired: "Title is required",
      contentTooShort: "Content is too short",
      contentTooLong: "Content is too long",
      invalidFormat: "Invalid format",
      fileTooLarge: "File is too large",
      unsupportedFileType: "Unsupported file type",
      uploadError: "Upload error occurred",
      saveError: "Save error occurred",
      loadError: "Load error occurred",
      networkError: "Network error occurred",
      
      // Success Messages
      contentSaved: "Content saved successfully",
      contentPublished: "Content published successfully",
      contentDeleted: "Content deleted successfully",
      contentUpdated: "Content updated successfully",
      contentCreated: "Content created successfully",
      imageUploaded: "Image uploaded successfully",
      contactInfoAdded: "Contact information added successfully",
      contactInfoUpdated: "Contact information updated successfully",
      contactInfoDeleted: "Contact information deleted successfully",
      
      // Additional Static Content Translations
      manageContactInformation: "Manage contact information",
      addNewContactInformation: "Add new contact information",
      updateContactInformation: "Update contact information",
      enterContactValue: "Enter contact value",
      enterArabicLabel: "Enter Arabic label",
      enterEnglishLabel: "Enter English label",
      manageGalleryImages: "Manage gallery images",
      uploadNewImagesToGallery: "Upload new images to gallery",
      orClickToSelectFiles: "or click to select files",
      searchImages: "Search images",
      allCategories: "All Categories",
      apartments: "Apartments",
      amenities: "Amenities",
      location: "Location",
      searchLocation: "Search for a location...",
      useCurrentLocation: "Use current location",
      selectedLocation: "Selected Location",
      coordinates: "Coordinates",
      cityOrRegion: "City or Region",
      events: "Events",
      editImage: "Edit Image",
      deleteImage: "Delete Image",
      downloadImage: "Download Image",
      updateImageMetadata: "Update image metadata",
      viewLiveSite: "View Live Site",
      fullScreen: "Full Screen",
      desktop: "Desktop",
      mobile: "Mobile",
      print: "Print",
      home: "Home",
      aboutUs: "About Us",
      contact: "Contact",
      gallery: "Gallery",
      selectPageToPreview: "Select a page to preview",
      allRightsReserved: "All rights reserved",
      language: "Language",
      direction: "Direction",
      lastUpdated: "Last Updated",
      activate: "Activate",
      deactivate: "Deactivate",
      
      // Contact Management Additional Translations
      viewContactInfo: "View Contact Information",
      viewContactInformation: "View contact information details",
      contactStatistics: "Contact Statistics",
      activeStatus: "Active Status",
      close: "Close",
      confirmDeleteContact: "Are you sure you want to delete this contact information? This action cannot be undone.",

      // Language
      systemLanguage: "Language",
      english: "English",
      arabic: "العربية",
      switchLanguage: "Switch Language",

      // Room Management
      rooms: "Property",
      roomManagement: "Property Management",
      propertyTypes: "Property Types",
      createPropertyType: "Create Property Type",
      updatePropertyType: "Update Property Type",
      deletePropertyType: "Delete Property Type",
      seedPropertyTypes: "Seed Property Types",
      propertyTypeName: "Property Type Name",
      propertyTypeDescription: "Property Type Description",
      propertyTypeIcon: "Property Type Icon",
      
      // Property Management
      createProperty: "Create Property",
      updateProperty: "Update Property",
      deleteProperty: "Delete Property",
      propertyName: "Property Name",
      propertyDescription: "Property Description",
      propertyType: "Property Type",
      address: "Address",
      latitude: "Latitude",
      longitude: "Longitude",
      fullPrice: "Full Price",
      depositType: "Deposit Type",
      depositValue: "Deposit Value",
      capacity: "Capacity",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      checkInTime: "Check-in Time",
      checkOutTime: "Check-out Time",
      media: "Media",
      featured: "Featured",
      
      // Property Types
      apartment: "Apartment",
      suite: "Suite",
      luxuryRoom: "Luxury Room",
      villa: "Villa",
      studio: "Studio",
      
      // Property Type Management
      viewPropertyType: "View Property Type",
      editPropertyType: "Edit Property Type",
      confirmDeletePropertyType: "Are you sure you want to delete this property type?",
      propertyTypeDeleted: "Property type deleted successfully",
      propertyTypeCreated: "Property type created successfully",
      propertyTypeUpdated: "Property type updated successfully",
      noPropertyTypes: "No property types found",
      addFirstPropertyType: "Add your first property type",
      
      // Property Type Form
      englishInformation: "English Information",
      arabicInformation: "Arabic Information",
      nameEnglish: "Name (English)",
      nameArabic: "Name (Arabic)",
      descriptionEnglish: "Description (English)",
      descriptionArabic: "Description (Arabic)",
      
      // Property Type View
      propertyTypeInformation: "Property Type Information",
      englishName: "English Name",
      arabicName: "Arabic Name",
      englishDescription: "English Description",
      arabicDescription: "Arabic Description",
      statistics: "Statistics",
      properties: "Properties",
      activeBookings: "Active Bookings",
      totalRevenue: "Total Revenue",
      totalProducts: "Total Products",
      totalOrders: "Total Orders",
      activeOrders: "Active Orders",
      totalEarnings: "Total Earnings",
      allOrders: "All Orders",
      productsInCatalog: "Products in Catalog",
      paymentMetrics: "Payment Metrics",
      reviewMetrics: "Review Metrics",
      successfulPayments: "Successful Payments",
      failedPayments: "Failed Payments",
      successRate: "Success Rate",
      paymentProviders: "Payment Providers",
      totalReviews: "Total Reviews",
      positiveReviews: "Positive Reviews",
      satisfactionRate: "Satisfaction Rate",
      operationalMetrics: "Operational Metrics",
      businessOperations: "Business Operations",
      growthMetrics: "Growth Metrics",
      performanceTrends: "Performance Trends",
      userGrowth: "User Growth",
      revenueGrowth: "Revenue Growth",
      orderGrowth: "Order Growth",
      bookingGrowth: "Booking Growth",
      current: "Current",
      previous: "Previous",
      bookingsByStatus: "Bookings by Status",
      ordersByStatus: "Orders by Status",
      averageBookingValue: "Average Booking Value",
      averageOrderValue: "Average Order Value",
      cancellationRate: "Cancellation Rate",
      userMetrics: "User Metrics",
      productMetrics: "Product Metrics",
      byCategory: "By Category",
      byBrand: "By Brand",
      topPerformers: "Top Performers",
      order: "Order",
      product: "Product",
      vsPreviousPeriod: "vs previous period",
      // Orders Management
      manageOrders: "Manage customer orders",
      pendingPayment: "Pending Payment",
      reviewingPayment: "Reviewing Payment",
      paid: "Paid",
      processing: "Processing",
      shipped: "Shipped",
      outForDelivery: "Out for Delivery",
      completed: "Completed",
      cancelled: "Cancelled",
      bankTransfer: "Bank Transfer",
      cashOnDelivery: "Cash on Delivery",
      online: "Online",
      receiptStatus: "Receipt Status",
      receipt: "Receipt",
      orderDetails: "Order Details",
      viewOrderInformation: "View detailed order information",
      customerInformation: "Customer Information",
      itemsSummary: "Items Summary",
      viewReceipt: "View Receipt",
      perPage: "per page",
      errorLoadingOrders: "Error loading orders",
      noOrdersFound: "No orders found",
      orderId: "Order ID",
      itemsCount: "Items Count",
      itemId: "Item ID",
      quantity: "Quantity",
      subtotal: "Subtotal",
      allMethods: "All Methods",
      allStatuses: "All Statuses",
      date: "Date",
      updateStatus: "Update Status",
      updateOrderStatus: "Update Order Status",
      updateOrderStatusDescription: "Update the status of this order",
      approveReceipt: "Approve Receipt",
      rejectReceipt: "Reject Receipt",
      confirmApproveReceipt: "Are you sure you want to approve this receipt?",
      rejectReceiptDescription: "Provide a reason for rejecting this receipt",
      orderStatusUpdated: "Order status updated successfully",
      failedToUpdateOrderStatus: "Failed to update order status",
      receiptApproved: "Receipt approved successfully",
      failedToApproveReceipt: "Failed to approve receipt",
      receiptRejected: "Receipt rejected successfully",
      failedToRejectReceipt: "Failed to reject receipt",
      pleaseSelectStatus: "Please select a status",
      pleaseEnterRemarks: "Please enter rejection remarks",
      enterRemarks: "Enter remarks (optional)",
      enterRejectionReason: "Enter rejection reason...",
      remarks: "Remarks",
      optional: "Optional",
      rejecting: "Rejecting...",
      openMenu: "Open menu",
      noItems: "No items found",
      noOrderData: "No order data available",
      startDate: "Start Date",
      endDate: "End Date",
      reset: "Reset",
      filters: "Filters",
      refresh: "Refresh",
      totalAmount: "Total Amount",
      paymentMethod: "Payment Method",
      customer: "Customer",
      address: "Address",
      updatedAt: "Updated At",
      price: "Price",
      selectStatus: "Select Status",
      saving: "Saving...",
      to: "to",
      showing: "Showing",
      previous: "Previous",
      next: "Next",
      page: "Page",
      of: "of",
      loading: "Loading",
      success: "Success",
      error: "Error",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      product: "Product",
      sku: "SKU",
      currentOccupancy: "Current Occupancy",
      latestReviews: "Latest Reviews",
      positive: "Positive",
      negative: "Negative",
      satisfaction: "Satisfaction",
      bookingStatusOverview: "Booking Status Overview",
      confirmed: "Confirmed",
      cancelled: "Cancelled",
      recentBookings: "Recent Bookings",
      noRecentActivity: "No Recent Activity",
      transactions: "transactions",
      count: "Count",
      paymentMethods: "Payment Methods",
      metadata: "Metadata",
      createdAt: "Created At",
      
      // Property Management
      confirmDeleteProperty: "Are you sure you want to delete this property? This action cannot be undone.",
      propertyDeleted: "Property deleted successfully",
      propertyCreated: "Property created successfully",
      propertyUpdated: "Property updated successfully",
      noProperties: "No properties found",
      addFirstProperty: "Add your first property",
      managePropertyInventory: "Manage your property inventory and room types",
      failedToDeletePropertyType: "Failed to delete property type.",
      failedToDeleteProperty: "Failed to delete property.",
      
      // Amenities
      wifi: "WiFi",
      parking: "Parking",
      kitchen: "Kitchen",
      airConditioning: "Air Conditioning",
      swimmingPool: "Swimming Pool",
      gym: "Gym",
      spa: "Spa",
      restaurant: "Restaurant",
      roomService: "Room Service",
      laundry: "Laundry",
      balcony: "Balcony",
      seaView: "Sea View",
      cityView: "City View",
      
      // Deposit Types
      fixed: "Fixed",
      percentage: "Percentage",
      
      // Media Management
      uploadMedia: "Upload Media",
      mediaFiles: "Media Files",
      primaryImage: "Primary Image",
      mediaTitle: "Media Title",
      mediaDescription: "Media Description",
      selectFiles: "Select Files",
      dragDropFiles: "Drag & drop files here, or click to select",
      removeMedia: "Remove Media",
      setAsPrimary: "Set as Primary",
      mediaUploaded: "Media uploaded successfully",
      mediaRemoved: "Media removed successfully",
      primaryImageSet: "Primary image set successfully",
      supportedFormats: "Supported formats: JPG, PNG, GIF, MP4, MOV",
      mediaDetails: "Media Details",
      
      // Room Statistics
      roomStats: "Room Statistics",
      totalProperties: "Total Properties",
      activeProperties: "Active Properties",
      occupancyRate: "Occupancy Rate",
      topPerformingTypes: "Top Performing Types",
      averagePrice: "Average Price",
      
      // Filters and Search
      minPrice: "Min Price",
      maxPrice: "Max Price",
      availableOnly: "Available Only",
      sortBy: "Sort By",
      sortOrder: "Sort Order",
      ascending: "Ascending",
      descending: "Descending",
      price: "Price",
      sortByName: "Property Name",
      updatedAt: "Updated At",

      // =========== COUPONS ===========
      coupons: "Coupons",
      couponsTitle: "Coupon Management",
      couponsSubtitle: "Create and manage discount coupons",
      createCoupon: "Create Coupon",
      editCoupon: "Edit Coupon",
      deleteCoupon: "Delete Coupon",
        couponName: "Coupon Name",
        discountType: "Discount Type",
        discountValue: "Discount Value",
        fixedAmount: "Fixed Amount",
      minOrderAmount: "Minimum Order Amount",
      maxDiscountAmount: "Maximum Discount Amount",
      usageLimit: "Usage Limit",
      validFrom: "Valid From",
      validUntil: "Valid Until",
      totalUsage: "Total Usage",
      remainingUsage: "Remaining Usage",
      couponStats: "Coupon Statistics",
      totalCoupons: "Total Coupons",
      activeCoupons: "Active Coupons",
      expiredCoupons: "Expired Coupons",
      searchCoupons: "Search by coupon code or description...",
      exportCoupons: "Export Coupons",
      filtered: "filtered",
      showing: "Showing",
      of: "of",
      noCoupons: "No coupons found",
      amount: "Amount",
      flat: "Flat",
      duplicateCouponCode: "A coupon with this code already exists",
      editCoupon: "Edit Coupon",
      editCouponDescription: "Update coupon details",
      
      // Reviews Management
      reviews: "Reviews",
      reviewsSubtitle: "Manage customer reviews and ratings",
      totalReviews: "Total Reviews",
      pendingReviews: "Pending Reviews",
      approvedReviews: "Approved Reviews",
      rejectedReviews: "Rejected Reviews",
      featuredReviews: "Featured Reviews",
      averageRating: "Average Rating",
      searchReviews: "Search by comment, user, or property...",
      allRatings: "All Ratings",
      allReviews: "All Reviews",
      notFeatured: "Not Featured",
      reviewsList: "Reviews List",
      manageReviews: "Manage customer reviews and ratings",
      noReviews: "No reviews found",
      noReviewsMatch: "No reviews match your current filters",
      customer: "Customer",
      property: "Property",
      rating: "Rating",
      comment: "Comment",
      featured: "Featured",
      date: "Date",
      actions: "Actions",
      reviewDetails: "Review Details",
      viewReviewDetails: "View detailed information about this review",
      booking: "Booking",
      yes: "Yes",
      no: "No",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      deleteReview: "Delete Review",
      deleteReviewConfirmation: "Are you sure you want to delete this review? This action cannot be undone.",
      reviewUpdatedSuccessfully: "Review updated successfully",
      reviewDeletedSuccessfully: "Review deleted successfully",
      reviewFeaturedToggled: "Review featured status updated",
      addReview: "Add Review",
      addReviewDescription: "Create a new review for a booking",
      bookingId: "Booking ID",
      bookingIdRequired: "Booking ID is required",
      commentRequired: "Comment is required",
      ratingInvalid: "Rating must be between 1 and 5",
      enterComment: "Enter your review comment...",
      mediaUrls: "Media URLs (Optional)",
      enterMediaUrls: "Enter media URLs, one per line:",
      mediaUrlsHelp: "Enter one URL per line. Leave empty if no media.",
      createReview: "Create Review",
      creating: "Creating...",
      reviewCreatedSuccessfully: "Review created successfully",
      
      // Payment Transactions Management
      payments: "Payments",
      paymentTransactions: "Payment Transactions",
      paymentTransactionsTitle: "Payment Transactions",
      paymentTransactionsSubtitle: "View and manage all payment transactions",
      paymentLogs: "Payment Logs",
      viewAllTransactionInformation: "View all transaction information and related data",
      transactionInformation: "Transaction Information",
      internalTransactionId: "Internal Transaction ID",
      gatewayOrderId: "Gateway Order ID",
      gatewaySessionId: "Gateway Session ID",
      processedAt: "Processed At",
      errorMessage: "Error Message",
      providerName: "Provider Name",
      merchantId: "Merchant ID",
      bookingInformation: "Booking Information",
      bookingStatus: "Booking Status",
      checkIn: "Check In",
      checkOut: "Check Out",
      totalPrice: "Total Price",
      depositAmount: "Deposit Amount",
      guestCount: "Guest Count",
      specialRequests: "Special Requests",
      userInformation: "User Information",
      gatewayResponse: "Gateway Response",
      bookingMetadata: "Booking Metadata",
      webhookData: "Webhook Data",
      providerLogs: "Provider Logs",
      providerLogsTitle: "Payment Provider Logs",
      providerLogsSubtitle: "View payment provider API logs and responses",
      transactionDetails: "Transaction Details",
      transactionId: "Transaction ID",
      bookingId: "Booking ID",
      userId: "User ID",
      providerCode: "Provider",
      paymentMethod: "Payment Method",
      amount: "Amount",
      status: "Status",
      createdAt: "Created At",
      updatedAt: "Updated At",
      transactionStatus: "Transaction Status",
      paymentState: "Payment State",
      internalOrderState: "Internal Order State",
      actionRequired: "Action Required",
      notes: "Notes",
      providerResponse: "Provider Response",
      viewDetails: "View Details",
      capture: "Capture",
      cancel: "Cancel",
      refund: "Refund",
      reconcile: "Reconcile",
      captureTransaction: "Capture Transaction",
      cancelTransaction: "Cancel Transaction",
      refundTransaction: "Refund Transaction",
      refundDescription: "Enter refund details. This will process a refund for the transaction.",
      referenceId: "Reference ID",
      enterReferenceId: "Enter reference ID (idempotency key)",
      referenceIdDescription: "Unique identifier for this refund request",
      enterRefundReason: "Enter reason for refund",
      reconcileTransaction: "Reconcile Transaction",
      captureAmount: "Capture Amount",
      refundAmount: "Refund Amount",
      enterAmount: "Enter amount",
      amountRequired: "Amount is required",
      amountMustBePositive: "Amount must be positive",
      amountExceedsTransaction: "Amount exceeds transaction amount",
      defaultToFullAmount: "Leave empty to use full transaction amount",
      confirmCapture: "Are you sure you want to capture this transaction?",
      confirmCancel: "Are you sure you want to cancel this transaction?",
      confirmRefund: "Are you sure you want to refund this transaction?",
      transactionCaptured: "Transaction captured successfully",
      transactionCancelled: "Transaction cancelled successfully",
      transactionRefunded: "Transaction refunded successfully",
      transactionReconciled: "Transaction reconciled successfully",
      failedToCapture: "Failed to capture transaction",
      failedToCancel: "Failed to cancel transaction",
      failedToRefund: "Failed to refund transaction",
      failedToReconcile: "Failed to reconcile transaction",
      failedToLoadTransactions: "Failed to load transactions",
      failedToLoadTransaction: "Failed to load transaction details",
      failedToLoadLogs: "Failed to load provider logs",
      noTransactionsFound: "No transactions found",
      noLogsFound: "No logs found",
      logDetails: "Log Details",
      viewAllLogInformation: "View all log information including request and response data",
      basicInformation: "Basic Information",
      logId: "Log ID",
      paymentMethodId: "Payment Method ID",
      requestType: "Request Type",
      requestUrl: "Request URL",
      requestBody: "Request Body",
      responseBody: "Response Body",
      statusCode: "Status Code",
      executionTime: "Execution Time",
      context: "Context",
      gatewayOrderId: "Gateway Order ID",
      gatewaySessionId: "Gateway Session ID",
      allRequestTypes: "All Request Types",
      allStatusCodes: "All Status Codes",
      success: "Success",
      loadingTransactions: "Loading transactions...",
      loadingTransaction: "Loading transaction details...",
      loadingLogs: "Loading logs...",
      filterByProvider: "Filter by Provider",
      filterByStatus: "Filter by Status",
      filterByBooking: "Filter by Booking",
      filterByUser: "Filter by User",
      filterByDate: "Filter by Date",
      dateFrom: "Date From",
      dateTo: "Date To",
      amountMin: "Minimum Amount",
      amountMax: "Maximum Amount",
      clearFilters: "Clear Filters",
      applyFilters: "Apply Filters",
      searchTransactions: "Search transactions...",
      searchLogs: "Search logs...",
      allProviders: "All Providers",
      allStatuses: "All Statuses",
      transactionStatusPending: "Pending",
      transactionStatusAuthorized: "Authorized",
      transactionStatusPaid: "Paid",
      transactionStatusRefunded: "Refunded",
      transactionStatusCancelled: "Cancelled",
      transactionStatusFailed: "Failed",
      showingResults: "Showing",
      to: "to",
      of: "of",
      results: "results",
      page: "Page",
      next: "Next",
      previous: "Previous",
      itemsPerPage: "Items per page",
      booking: "Booking",
      user: "User",
      provider: "Provider",
      method: "Method",
      totalAmount: "Total Amount",
      transactionDate: "Transaction Date",
      lastUpdated: "Last Updated",
      viewTransaction: "View Transaction",
      backToList: "Back to Transactions",
      transactionInformation: "Transaction Information",
      relatedInformation: "Related Information",
      bookingInformation: "Booking Information",
      userInformation: "User Information",
      paymentMethodInformation: "Payment Method Information",
      actionResults: "Action Results",
      step: "Step",
      responseStatus: "Response Status",
      responseData: "Response Data",
      noResponseData: "No response data available",
      expandResponse: "Expand Response",
      collapseResponse: "Collapse Response",
      logLevel: "Log Level",
      logMessage: "Message",
      logTimestamp: "Timestamp",
      logRequest: "Request",
      logResponse: "Response",
      filterByLevel: "Filter by Level",
      allLevels: "All Levels",
      info: "Info",
      error: "Error",
      warning: "Warning",
      debug: "Debug",
      youDoNotHavePermission: "You do not have permission to view payment transactions.",
      youDoNotHavePermissionToEdit: "You do not have permission to perform this action.",
      
      // Static Pages Management
      staticContent: "Static Content",
      staticContentSubtitle: "Manage static pages and content",
      addPage: "Add Page",
      totalPages: "Total Pages",
      activePages: "Active Pages",
      inactivePages: "Inactive Pages",
      searchPages: "Search by title, slug, or content...",
      pagesList: "Pages List",
      managePages: "Manage your static pages and content",
      noPages: "No pages found",
      noPagesMatch: "No pages match your current filters",
      createFirstPage: "Create your first page",
      title: "Title",
      slug: "Slug",
      lastUpdated: "Last Updated",
      editPage: "Edit Page",
      editPageDescription: "Update page content and settings",
      addPageDescription: "Create a new static page",
      titleEnglish: "Title (English)",
      titleArabic: "Title (Arabic)",
      contentEnglish: "Content (English)",
      contentArabic: "Content (Arabic)",
      slugHelp: "URL-friendly identifier (e.g., privacy-policy)",
      htmlSupported: "HTML tags are supported",
      updatePage: "Update Page",
      createPage: "Create Page",
      saving: "Saving...",
      pageDetails: "Page Details",
      viewPageDetails: "View detailed information about this page",
      deletePage: "Delete Page",
      deletePageConfirmation: "Are you sure you want to delete this page? This action cannot be undone.",
      pageCreatedSuccessfully: "Page created successfully",
      pageUpdatedSuccessfully: "Page updated successfully",
      pageDeletedSuccessfully: "Page deleted successfully",
      pageStatusUpdated: "Page status updated",
      titleArRequired: "Arabic title is required",
      titleEnRequired: "English title is required",
      slugRequired: "Slug is required",
      duplicateSlug: "A page with this slug already exists",

      // Payment Methods Management
      paymentMethods: "Payment Methods",
      paymentMethodsList: "Payment Methods List",
      addPaymentMethod: "Add Payment Method",
      editPaymentMethod: "Edit Payment Method",
      paymentMethodDetails: "Payment Method Details",
      totalMethods: "Total Methods",
      activeMethods: "Active Methods",
      inactiveMethods: "Inactive Methods",
      searchPaymentMethods: "Search payment methods...",
      noPaymentMethods: "No Payment Methods Found",
      noPaymentMethodsMatch: "No payment methods match your search criteria",
      createFirstPaymentMethod: "Create Your First Payment Method",
      provider: "Provider",
      providerName: "Provider Name",
      providerCode: "Provider Code",
      providerLogo: "Provider Logo",
      code: "Code",
      displayOrder: "Display Order",
      imageUrl: "Image URL",
      publicKey: "Public Key",
      secretKey: "Secret Key",
      merchantId: "Merchant ID",
      callbackUrl: "Callback URL",
      enterProviderName: "Enter provider name",
      enterProviderCode: "Enter provider code",
      enterImageUrl: "Enter image URL",
      enterPublicKey: "Enter public key",
      enterSecretKey: "Enter secret key",
      enterMerchantId: "Enter merchant ID",
      enterCallbackUrl: "Enter callback URL",
      createPaymentMethod: "Create Payment Method",
      updatePaymentMethod: "Update Payment Method",
      deletePaymentMethod: "Delete Payment Method",
      deletePaymentMethodConfirmation: "Are you sure you want to delete this payment method? This action cannot be undone.",
      paymentMethodCreatedSuccessfully: "Payment method created successfully",
      paymentMethodUpdatedSuccessfully: "Payment method updated successfully",
      paymentMethodDeletedSuccessfully: "Payment method deleted successfully",
      paymentMethodStatusToggled: "Payment method status updated successfully",
      failedToCreatePaymentMethod: "Failed to create payment method",
      failedToUpdatePaymentMethod: "Failed to update payment method",
      failedToDeletePaymentMethod: "Failed to delete payment method",
      failedToTogglePaymentMethodStatus: "Failed to update payment method status",
      providerNameRequired: "Provider name is required",
      providerCodeRequired: "Provider code is required",
      descriptionRequired: "Description is required",
      allStatuses: "All Statuses",
      createdAt: "Created At",
      paymentMethodsEndpointNotAvailable: "Payment Methods Backend Not Available",
      paymentMethodsEndpointNotImplemented: "The payment methods API endpoints are not yet implemented on the backend server. Please implement the required endpoints to enable payment methods management.",
      requiredEndpoints: "Required API Endpoints",
      retryConnection: "Retry Connection",
      testApi: "Test API",
      testGetApi: "Test GET API",
      testToggleApi: "Test Toggle API",
      
      // Language indicator for LTR
      language: "en",
      
      // General & Notification Settings
      generalAndNotifications: "General & Notifications",
      smsProviderSettings: "SMS Provider Settings",
      smsProviderConfiguration: "Configure SMS service provider for notifications",
      smsApiKey: "SMS API Key",
      enterSmsApiKey: "Enter SMS API key",
      senderId: "Sender ID",
      enterSenderId: "Enter sender ID",
      firebaseSettings: "Firebase Settings",
      firebaseConfiguration: "Configure Firebase for push notifications",
      firebaseServerKey: "Firebase Server Key",
      enterFirebaseServerKey: "Enter Firebase server key",
      pushNotifications: "Push Notifications",
      pushNotificationsDesc: "Send push notifications via Firebase",
      blocked: "Blocked",
      saveAllSettings: "Save All Settings",
      settingUpdatedSuccessfully: "Setting updated successfully",
      settingsUpdatedSuccessfully: "Settings updated successfully",
      failedToUpdateSetting: "Failed to update setting",
      failedToUpdateSettings: "Failed to update settings",
      createSetting: "Create Setting",
      createSettingDescription: "Add a new system setting",
      settingCreatedSuccessfully: "Setting created successfully",
      failedToCreateSetting: "Failed to create setting",
      key: "Key",
      value: "Value",
      group: "Group",
      description: "Description",
      encryptValue: "Encrypt Value",
      enterSettingKey: "Enter setting key",
      enterSettingValue: "Enter setting value",
      enterSettingDescription: "Enter setting description",
      keyRequired: "Key is required",
      valueRequired: "Value is required",
      invalidKeyFormat: "Invalid key format",
      keyFormatDescription: "Key must contain only letters, numbers, and underscores",
      general: "General",
      sms: "SMS",
      firebase: "Firebase",
      email: "Email",
      creating: "Creating...",
      manageSettings: "Manage Settings",
      manageSettingsDescription: "View and manage all system settings",
      allGroups: "All Groups",
      encrypted: "Encrypted",
      lastUpdated: "Last Updated",
      noValue: "No Value",
      noDescription: "No Description",
      yes: "Yes",
      no: "No",
      noSettings: "No Settings",
      noSettingsDescription: "No settings found. Create your first setting to get started.",
      createFirstSetting: "Create First Setting",
      settingsLoadError: "Failed to Load Settings",
      settingsLoadErrorDescription: "There was an error loading the settings data.",
      retry: "Retry",
      deleteNotImplemented: "Delete Not Available",
      deleteSettingNotImplemented: "Delete setting functionality is not implemented yet.",
      editSetting: "Edit Setting",
      editSettingDescription: "Update the setting value and description",
      updateSetting: "Update Setting",
      updating: "Updating...",
      keyCannotBeChanged: "Key cannot be changed when editing",
      groupCannotBeChanged: "Group cannot be changed when editing",
      cannotBeChanged: "cannot be changed",
      settingDeletedSuccessfully: "Setting deleted successfully",
      failedToDeleteSetting: "Failed to delete setting",
      confirmDeleteSetting: "Are you sure you want to delete the setting '{{key}}'? This action cannot be undone.",
      showingResults: "Showing {{start}} to {{end}} of {{total}} results",
      itemsPerPage: "Items per page",
      previous: "Previous",
      next: "Next",
      roles: "Roles",
      rolesDescription: "Manage user roles and their permissions",
      createRole: "Create Role",
      rolesComingSoon: "Roles Management Coming Soon",
      rolesComingSoonDescription: "Role management functionality will be implemented here.",
      permissions: "Permissions",
      permissionsDescription: "Manage system permissions and access control",
      createPermission: "Create Permission",
      permissionsComingSoon: "Permissions Management Coming Soon",
      permissionsComingSoonDescription: "Permission management functionality will be implemented here.",
      
      // Notifications System
      notifications: "Notifications",
      myNotifications: "My Notifications",
      adminNotifications: "Admin Notifications",
      manageYourNotifications: "Manage your notifications and preferences",
      manageAndSendNotifications: "Manage and send notifications to users",
      totalNotifications: "Total Notifications",
      unreadNotifications: "Unread Notifications",
      readNotifications: "Read Notifications",
      markAsRead: "Mark as Read",
      markAllAsRead: "Mark All as Read",
      deleteNotification: "Delete Notification",
      deleteNotificationConfirmation: "Are you sure you want to delete this notification? This action cannot be undone.",
      searchNotifications: "Search notifications...",
      allTypes: "All Types",
      allStatuses: "All Statuses",
      read: "Read",
      unread: "Unread",
      noNotifications: "No Notifications",
      noNotificationsMatch: "No notifications match your criteria",
      youWillSeeNotificationsHere: "You'll see your notifications here when you receive them",
      tryAdjustingYourFilters: "Try adjusting your search filters",
      viewAllNotifications: "View All Notifications",
      
      // Notification Settings
      notificationSettings: "Notification Settings",
      configureYourNotificationPreferences: "Configure your notification preferences",
      pushNotifications: "Push Notifications",
      emailNotifications: "Email Notifications",
      smsNotifications: "SMS Notifications",
      notificationTypes: "Notification Types",
      bookingUpdates: "Booking Updates",
      promotions: "Promotions",
      systemUpdates: "System Updates",
      enableBrowserNotifications: "Enable browser notifications to receive real-time updates",
      enableNotifications: "Enable Notifications",
      
      // Notification Types
      booking: "Booking",
      promotion: "Promotion",
      review: "Review",
      systemUpdate: "System Update",
      payment: "Payment",
      general: "General",
      
      // Admin Notifications
      sendNotification: "Send Notification",
      bulkNotifications: "Bulk Notifications",
      statistics: "Statistics",
      sendNotificationToSpecificUsers: "Send notification to specific users",
      sendNotificationToMultipleUsers: "Send notification to multiple users based on filters",
      userIds: "User IDs",
      enterUserIds: "Enter user IDs (comma separated)",
      separateUserIdsWithCommas: "Separate multiple user IDs with commas",
      notificationType: "Notification Type",
      enterNotificationTitle: "Enter notification title",
      message: "Message",
      enterNotificationMessage: "Enter notification message",
      deliveryChannels: "Delivery Channels",
      pushNotification: "Push Notification",
      email: "Email",
      sms: "SMS",
      sending: "Sending...",
      reset: "Reset",
      
      // Bulk Notifications
      userRole: "User Role",
      selectRole: "Select Role",
      allRoles: "All Roles",
      customer: "Customer",
      driver: "Driver",
      staff: "Staff",
      admin: "Admin",
      userStatus: "User Status",
      lastActiveAfter: "Last Active After",
      sendBulkNotification: "Send Bulk Notification",
      
      // Notification Stats
      notificationStatistics: "Notification Statistics",
      viewDetailedNotificationStats: "View detailed notification statistics and analytics",
      totalSent: "Total Sent",
      totalDelivered: "Total Delivered",
      totalRead: "Total Read",
      totalClicked: "Total Clicked",
      deliveryRate: "Delivery Rate",
      readRate: "Read Rate",
      clickRate: "Click Rate",
      startDate: "Start Date",
      endDate: "End Date",
      applyFilters: "Apply Filters",
      loadingStats: "Loading Statistics...",
      byType: "By Type",
      byChannel: "By Channel",
      noDataAvailable: "No data available",
      noUsersFound: "No Users Found",
      noUsersDescription: "There are no users available at the moment.",
      noPropertiesFound: "No Properties Found",
      noPropertiesDescription: "There are no properties available at the moment.",
      noBookingsFound: "No Bookings Found",
      noBookingsDescription: "There are no bookings available at the moment.",
      noSettingsFound: "No Settings Found",
      noSettingsDescription: "There are no settings available at the moment.",
      propertyTypes: "Property Types",
      typeArabic: "Type (Arabic)",
      avgPrice: "Average Price",
      topPerformingProperties: "Top Performing Properties",
      recentBookings: "Recent Bookings",
      count: "Count",
      lastSignup: "Last Signup",
      financialSummary: "Financial Summary",
      allTimeRevenue: "All time revenue",
      pendingPayments: "Pending Payments",
      awaitingPayment: "Awaiting payment",
      refundsIssued: "Refunds Issued",
      totalRefunds: "Total refunds",
      commissionEarned: "Commission Earned",
      platformCommission: "Platform commission",
      systemInformation: "System Information",
      systemUptime: "System Uptime",
      serverUptime: "Server uptime",
      minutes: "minutes",
      lastUpdate: "Last Update",
      dataLastUpdated: "Data last updated",
      registeredUsers: "Registered users",
      listedProperties: "Listed properties",
      noAnalyticsData: "No analytics data available at the moment.",
      noPaymentData: "No payment methods data available at the moment.",
      userDistribution: "User Distribution",
      usersByRole: "Users by Role",
      propertyTypesDistribution: "Property Types Distribution",
      propertiesByType: "Properties by Type",
      financialOverview: "Financial Overview",
      revenueAndExpenses: "Revenue and Expenses",
      noUserData: "No user data available at the moment.",
      noPropertyData: "No property data available at the moment.",
      noFinancialData: "No financial data available at the moment.",
      
      // Additional Translations
      searchAndFilters: "Search and Filters",
      couponsList: "Coupons List",
      sendNotificationToUsers: "Send Notification to Users",
      notificationChannels: "Notification Channels",
      mailNotification: "Mail Notification",
      smsProvider: "SMS Provider",
      enableSmsNotifications: "Enable SMS Notifications",
      configurePlatformSettings: "Configure Platform Settings",
      badeel: "Emaar Platform",
      servicedApartments: "Emaar",
      
      // Success/Error Messages
      notificationSentSuccessfully: "Notification Sent Successfully",
      notificationHasBeenSent: "The notification has been sent to the selected users",
      bulkNotificationSentSuccessfully: "Bulk Notification Sent Successfully",
      bulkNotificationHasBeenSent: "The bulk notification has been sent to matching users",
      failedToSendNotification: "Failed to Send Notification",
      failedToSendBulkNotification: "Failed to Send Bulk Notification",
      validationError: "Validation Error",
      titleAndBodyRequired: "Title and message are required",
      selectAtLeastOneUser: "Please select at least one user",

      // Permissions Management
      totalPermissions: "Total Permissions",
      activePermissions: "Active Permissions", 
      inactivePermissions: "Inactive Permissions",
      searchPermissions: "Search permissions...",
      allResources: "All Resources",
      allActions: "All Actions",
      permissionsLoadError: "Failed to load permissions",
      permissionsEndpointNotAvailable: "Permissions endpoint not available",
      noPermissions: "No permissions found",
      noPermissionsDescription: "No permissions match your current filters.",
      createFirstPermission: "Create your first permission to get started.",
      resource: "Resource",
      action: "Action",
      permissionCreatedSuccessfully: "Permission created successfully",
      permissionUpdatedSuccessfully: "Permission updated successfully", 
      permissionDeletedSuccessfully: "Permission deleted successfully",
      permissionStatusToggled: "Permission status updated successfully",
      failedToCreatePermission: "Failed to create permission",
      failedToUpdatePermission: "Failed to update permission",
      failedToDeletePermission: "Failed to delete permission",
      failedToTogglePermissionStatus: "Failed to toggle permission status",
      confirmDeletePermission: "Are you sure you want to delete this permission?",
      editPermission: "Edit Permission",
      editPermissionDescription: "Update permission details and settings.",
      createPermissionDescription: "Add a new permission to the system.",
      enterPermissionName: "Enter permission name",
      enterPermissionDescription: "Enter permission description",
      enterResource: "Enter resource name",
      enterAction: "Enter action name",
      activePermission: "Active Permission",
      updatePermission: "Update Permission",
      resourceRequired: "Resource is required",
      actionRequired: "Action is required",
      
      // Role Permissions
      assignPermissions: "Assign Permissions",
      selectPermissions: "Select permissions for this role",
      noPermissionsSelected: "No permissions selected",
      permissionsSelected: "permissions selected",
      clearFilters: "Clear Filters",
      noPermissionsMatch: "No permissions match your filters",
      filtered: "filtered",
      noRolesMatch: "No roles match your search criteria",
      totalRoles: "Total Roles",
      activeRoles: "Active Roles", 
      inactiveRoles: "Inactive Roles",
      searchRoles: "Search roles...",
      rolesLoadError: "Failed to Load Roles",
      rolesEndpointNotAvailable: "Roles endpoint not available. Please ensure the backend API is running.",
      noRoles: "No Roles",
      noRolesDescription: "No roles found. Create your first role to get started.",
      createFirstRole: "Create First Role",
      roleCreatedSuccessfully: "Role created successfully",
      roleUpdatedSuccessfully: "Role updated successfully", 
      roleDeletedSuccessfully: "Role deleted successfully",
      roleStatusToggled: "Role status updated successfully",
      failedToCreateRole: "Failed to create role",
      failedToUpdateRole: "Failed to update role",
      failedToDeleteRole: "Failed to delete role",
      failedToToggleRoleStatus: "Failed to update role status",
      confirmDeleteRole: "Are you sure you want to delete the role '{{name}}'? This action cannot be undone.",
      nameRequired: "Name is required",
      descriptionRequired: "Description is required",
      deactivate: "Deactivate",
      activate: "Activate",
      editRole: "Edit Role",
      editRoleDescription: "Update role information and permissions",
      createRoleDescription: "Create a new role with specific permissions",
      enterRoleName: "Enter role name",
      enterRoleDescription: "Enter role description",
      activeRole: "Active role",
      updateRole: "Update Role",
      
      validateCoupon: "Validate Coupon",
      couponValidation: "Coupon Validation",
      orderAmount: "Order Amount",
      validate: "Validate",
      finalAmount: "Final Amount",
      generateCode: "Generate Code",
      copyCode: "Copy Code",
      couponCreated: "Coupon created successfully",
      couponUpdated: "Coupon updated successfully",
      couponDeleted: "Coupon deleted successfully",
      couponValidationSuccess: "Coupon is valid",
      couponValidationError: "Coupon validation failed",
      confirmDeleteCoupon: "Are you sure you want to delete this coupon?",
      noCouponsFound: "No coupons found",
      unlimited: "Unlimited",
      
      // Additional coupon translations
      copiedToClipboard: "Copied to clipboard",
      couponFound: "coupon found",
      couponsFound: "coupons found",
      noCouponsMatch: "No coupons match your search",
      allStatuses: "All Statuses",
      allTypes: "All Types",
      totalDiscountGiven: "Total discount given",
      basicInformation: "Basic Information",
      uniqueCode: "Enter a unique coupon code",
      discountConfiguration: "Discount Configuration",
      selectDiscountType: "Select discount type",
      amountInSAR: "Amount in SAR",
      minimumOrderAmount: "Minimum order amount required",
      maximumDiscountAmount: "Maximum discount amount (for percentage)",
      usageLimits: "Usage Limits",
      totalNumberOfTimes: "Total number of times this coupon can be used",
      numberOfTimesEachUser: "Number of times each user can use this coupon",
      validityPeriod: "Validity Period",
      applicability: "Applicability",
      leaveEmptyForAllCities: "Leave empty to apply to all cities",
      leaveEmptyForAllVehicleTypes: "Leave empty to apply to all vehicle types",
      enableOrDisable: "Enable or disable this coupon",
      updateCouponDetails: "Update coupon details and settings",
      createNewPromotional: "Create a new promotional discount coupon",
      detailedAnalytics: "Detailed analytics and insights",
      selectDateRange: "Select date range",
      last7Days: "Last 7 days",
      last30Days: "Last 30 days",
      last90Days: "Last 90 days",
      lastYear: "Last year",
      withoutCoupon: "Without coupon",
      withCoupon: "With coupon",
      revenueImpact: "Revenue Impact",
      averageIncreasePerOrder: "Average increase per order",
      dailyUsage: "Daily usage trends",
      usage: "uses",
      testValidationSystem: "Test the coupon validation system",
      calculationBreakdown: "Calculation Breakdown",
      originalAmount: "Original Amount",
      savings: "You Save",
      validationFailed: "Validation Failed",
      noDiscountApplied: "No discount applied",
      sampleCoupons: "Sample Coupons",
      useSampleCodes: "Use these sample codes to test the validation system",
      minOrder: "Min order",
      maxDiscount: "Max discount",
      reset: "Reset",
      couponsExportedSuccessfully: "Coupons exported successfully",
      failedToExportCoupons: "Failed to export coupons",
      best: "Best",

      // =========== NOTIFICATIONS ===========
      notificationsTitle: "Notification Management",
      notificationsSubtitle: "Send notifications to guests and staff",
      notificationsList: "Notifications List",
      createNotification: "Create Notification",
      createNewNotification: "Create New Notification",
      notificationTitle: "Notification Title",
      notificationMessage: "Notification Message",
      enterNotificationMessage: "Enter notification message",
      selectType: "Select Type",
      targetAudience: "Target Audience",
      selectTargetAudience: "Select Target Audience",
      allUsers: "All Users",
      allGuests: "All Guests",
      allStaff: "All Staff",
      specificProperty: "Specific Property",
      specificUsers: "Specific Users",
      selectProperties: "Select Properties",
      selectSpecificUsers: "Select Specific Users",
      pleaseSelectAtLeastOneProperty: "Please select at least one property",
      unknownTarget: "Unknown Target",
      scheduleFor: "Schedule For (Optional)",
      sendNow: "Send Now",
      totalSent: "Total Sent",
      scheduled: "Scheduled",
      totalUsers: "Total Users",
      activeCities: "Active Cities",
      notificationCreated: "Notification created successfully",
      notificationCreatedSuccessfully: "Notification created successfully",
      notificationFailed: "Failed to create notification",
      failedToCreateNotification: "Failed to create notification",
      pleaseFillRequiredFields: "Please fill in all required fields",
      pleaseSelectAtLeastOneCity: "Please select at least one city",
      pleaseSelectAtLeastOneUser: "Please select at least one user",
      
      // User selection for notifications
      selectUsers: "Select Users",
      usersSelected: "users selected",
      searchUsers: "Search users...",
      noUsersFound: "No users found",
      searchAndSelectUsersToSendNotifications: "Search and select users to send notifications to",
      loading: "Loading...",
      role: "Role",
      status: "Status",
      
      // Notification types (hotel-specific)
      notificationAnnouncement: "Announcement",
      notificationMaintenance: "Maintenance",
      notificationHousekeeping: "Housekeeping",
      notificationBooking: "Booking",
      notificationCheckin: "Check-in",
      notificationCheckout: "Check-out",
      notificationPromo: "Promotion",
      notificationAlert: "Alert",

      // =========== SETTINGS ===========
      settingsTitle: "System Settings",
      settingsSubtitle: "Manage system configuration and settings",
      generalSettings: "General Settings",
      systemSettings: "System Settings",
      manageYourProfileInformation: "Manage your profile information and preferences",
      profilePicture: "Profile Picture",
      changePhoto: "Change Photo",
      joined: "Joined",
      profileDetails: "Profile Details",
      enterFullName: "Enter your full name",
      enterEmail: "Enter your email",
      enterPhone: "Enter your phone number",
      department: "Department",
      enterDepartment: "Enter your department",
      location: "Location",
      enterLocation: "Enter your location",
      editProfile: "Edit Profile",
      profileUpdatedSuccessfully: "Profile updated successfully",
      failedToUpdateProfile: "Failed to update profile",
      languageSettings: "Language Settings",
      paymentSettings: "Payment Settings",
      notificationSettings: "Notification Settings",
      staffSettings: "Staff Management",
      
      // Table common terms
      showing: "Showing",
      of: "of",
      entries: "entries",
      previous: "Previous",
      next: "Next",
      first: "First",
      last: "Last",
      page: "Page",
      perPage: "Per page",
      searchPlaceholder: "Search...",
      allFilters: "All filters",
      staff: "Staff",
      
      // General Settings
      platformSettings: "Platform Settings",
      platformName: "Platform Name",
      enterPlatformName: "Enter platform name",
      defaultCurrency: "Default Currency",
      selectCurrency: "Select currency",
      timezone: "Timezone",
      selectTimezone: "Select timezone",
      riyadhTime: "Riyadh Time (UTC+3)",
      dubaiTime: "Dubai Time (UTC+4)",
      gmt: "Greenwich Mean Time (UTC+0)",
      est: "Eastern Standard Time (UTC-5)",
      commissionRate: "Commission Rate (%)",
      enterCommissionRate: "Enter commission rate",
      supportEmail: "Support Email",
      enterSupportEmail: "Enter support email",
      supportPhone: "Support Phone",
      enterSupportPhone: "Enter support phone",
      maxTripDistance: "Max Trip Distance (km)",
      enterMaxDistance: "Enter max distance",
      emergencyContact: "Emergency Contact",
      enterEmergencyContact: "Enter emergency contact",
      saveSettings: "Save Settings",
      settingsSaved: "Settings saved successfully",
      
      // Branding Settings
      brandingAppearance: "Branding & Appearance",
      companyLogo: "Company Logo URL",
      enterLogoUrl: "Enter logo URL",
      primaryBrandColor: "Primary Brand Color",
      hexColorCode: "Hex color code",
      companyDescription: "Company Description",
      defaultCompanyDescription: "Leading ride-sharing platform providing safe and reliable transportation services.",
      enterCompanyDescription: "Enter company description",
      favicon: "Favicon URL",
      enterFaviconUrl: "Enter favicon URL",
      secondaryBrandColor: "Secondary Brand Color",
      companyWebsite: "Company Website",
      enterWebsiteUrl: "Enter website URL",
      saveBranding: "Save Branding",

      // Language Settings
      defaultLanguage: "Default Language",
      selectLanguage: "Select language",
      currentLanguage: "Current Language",
      languageChanged: "Language changed successfully",

      // Payment Settings
      paymentGatewaySettings: "Payment Gateway Settings",
      saudiPaymentCard: "Saudi Payment Network",
      applePaymentService: "Apple Pay Service",
      tapPaymentGateway: "Tap Payment Gateway",
      buyNowPayLater: "Buy Now Pay Later Service",
      neoLeapPayment: "NeoLeap Payment Solution",
      moyasarPayment: "Moyasar Payment Gateway",
      apiKey: "API Key",
      enterApiKey: "Enter API key",
      secretKey: "Secret Key",
      enterSecretKey: "Enter secret key",
      merchantId: "Merchant ID",
      enterMerchantId: "Enter merchant ID",
      certificate: "Certificate",
      enterCertificate: "Enter certificate",
      savePaymentSettings: "Save Payment Settings",
      paymentSettingsSaved: "Payment settings saved successfully",

      // Notification Settings
      notificationPreferences: "Notification Preferences",
      emailNotifications: "Email Notifications",
      emailNotificationsDesc: "Receive notifications via email",
      smsNotifications: "SMS Notifications",
      smsNotificationsDesc: "Receive notifications via SMS",
      newBooking: "New Booking",
      driverAssigned: "Driver Assigned",
      tripCompleted: "Trip Completed",
      systemAlerts: "System Alerts",
      saveNotificationSettings: "Save Notification Settings",
      notificationSettingsSaved: "Notification settings saved successfully",

      // Staff Management
      adminUsersRoles: "Admin Users & Roles",
      addNewAdmin: "Add New Admin",
      addNewAdminUser: "Add New Admin User",
      name: "Name",
      fullName: "Full Name",
      email: "Email",
      securePassword: "Secure password",
      role: "Role",
      createAdmin: "Create Admin",
      editAdminUser: "Edit Admin User",
      updateAdmin: "Update Admin",
      noAdminUsers: "No admin users",
      getStartedByAddingAdmin: "Get started by adding an admin user.",
      
      // System Information
      systemInformation: "System Information",
      applicationVersion: "Application Version",
      databaseStatus: "Database Status",
      connected: "Connected",
      lastBackup: "Last Backup",
      systemUptime: "System Uptime",
      days: "days",
      hours: "hours",

      // =========== SUPPORT ===========
      supportTitle: "Support Management",
      supportSubtitle: "Manage customer support tickets and inquiries",
      supportTickets: "Support Tickets",
      createTicket: "Create Ticket",
      ticketStatus: "Ticket Status",
      openTickets: "Open Tickets",
      closedTickets: "Closed Tickets",
      pendingTickets: "Pending Tickets",
      assignedTo: "Assigned To",
      priority: "Priority",
      high: "High",
      medium: "Medium",
      low: "Low",
      ticketDetails: "Ticket Details",
      customerInfo: "Customer Information",
      issueDescription: "Issue Description",
      resolution: "Resolution",
      closeTicket: "Close Ticket",
      reopenTicket: "Reopen Ticket",
      assignTicket: "Assign Ticket",
      addComment: "Add Comment",
      supportComingSoon: "Support system coming soon",
      featureUnderDevelopment: "This feature is under development",
      awaitingResponse: "Awaiting response",
      thisWeek: "this week",
      registeredUsers: "Registered users",
      
      // Media Management
      mediaManagement: "Media Management",
      uploadAndManagePropertyMedia: "Upload and manage property media files",
      selectPropertyForMedia: "Select Property for Media Upload",
      selectProperty: "Select Property",
      uploadNewMedia: "Upload New Media",
      existingMedia: "Existing Media",
      noMediaFound: "No media files found",
      altText: "Alt Text",
      title: "Title",
      description: "Description",
      setPrimaryImage: "Set as Primary Image",
      primary: "Primary",
      enterAltText: "Enter alt text for accessibility",
      enterTitle: "Enter media title",
      enterDescription: "Enter media description",
      dropFilesHere: "Drop files here",
      orClickToSelect: "or click to select",
      selectFile: "Select File",
      changeFile: "Change File",
      uploadMedia: "Upload Media",
      uploading: "Uploading...",
      reset: "Reset",
      mediaUploadedSuccessfully: "Media uploaded successfully",
      failedToUploadMedia: "Failed to upload media",
      mediaDeletedSuccessfully: "Media deleted successfully",
      failedToDeleteMedia: "Failed to delete media",
      confirmDeleteMedia: "Are you sure you want to delete this media?",
      invalidFileType: "Invalid file type. Please select an image or video file",
      fileTooLarge: "File size must be less than 10MB",
      pleaseSelectFile: "Please select a file to upload",
      pleaseCompleteRequiredFields: "Please complete all required fields",
      mediaEndpointNotAvailable: "Media Management Not Available",
      mediaEndpointNotImplemented: "The media management endpoints are not yet implemented on your server.",
      implementEndpoints: "Please implement the following endpoints on your backend:"
    }
  },
  ar: {
    translation: {
      // App Name
      appName: "مجموعة إعمار للادولات الصحية ",
      
      // Navigation
      dashboard: "لوحة التحكم",
      products: "إدارة المنتجات",
      categories: "إدارة الفئات",
      brands: "إدارة العلامات التجارية",
      orders: "إدارة الطلبات",
      proDashboard: "لوحة التحكم المحترفة",
      analytics: "التحليلات",
      rooms: "الغرف",
      bookings: "الحجوزات",
      userManagement: "إدارة المستخدمين",
      reviews: "التقييمات",
      coupons: "الكوبونات والعروض",
      support: "الدعم الفني",
      reports: "التقارير",
      notifications: "الإشعارات",
      staticContent: "المحتوى الثابت",
      profileSettings: "إعدادات الملف الشخصي",
      settings: "الإعدادات",
      guests: "الضيوف",
      housekeeping: "النظافة",
      maintenance: "الصيانة",
      users: "المستخدمين",
      products: "إدارة المنتجات",
      categories: "إدارة الفئات",
      brands: "إدارة العلامات التجارية",
      orders: "إدارة الطلبات",
      collapseSidebar: "تصغير القائمة الجانبية",
      expandSidebar: "تكبير القائمة الجانبية",

      // Professional Dashboard
      dashboardOverview: "نظرة عامة على لوحة التحكم",
      welcomeBackMessage: "مرحباً بعودتك! إليك ما يحدث مع عملك اليوم.",
      totalRevenue: "إجمالي الإيرادات",
      totalProducts: "إجمالي المنتجات",
      totalOrders: "إجمالي الطلبات",
      activeOrders: "الطلبات النشطة",
      totalEarnings: "إجمالي الأرباح",
      allOrders: "جميع الطلبات",
      productsInCatalog: "المنتجات في الكتالوج",
      paymentMetrics: "مقاييس المدفوعات",
      reviewMetrics: "مقاييس التقييمات",
      successfulPayments: "المدفوعات الناجحة",
      failedPayments: "المدفوعات الفاشلة",
      successRate: "معدل النجاح",
      paymentProviders: "مقدمي خدمات الدفع",
      totalReviews: "إجمالي التقييمات",
      positiveReviews: "التقييمات الإيجابية",
      satisfactionRate: "معدل الرضا",
      operationalMetrics: "مقاييس التشغيل",
      businessOperations: "كفاءة التشغيل",
      growthMetrics: "مقاييس النمو",
      performanceTrends: "اتجاهات الأداء",
      userGrowth: "نمو المستخدمين",
      revenueGrowth: "نمو الإيرادات",
      orderGrowth: "نمو الطلبات",
      bookingGrowth: "نمو الحجوزات",
      current: "الحالي",
      previous: "السابق",
      bookingsByStatus: "الحجوزات حسب الحالة",
      ordersByStatus: "الطلبات حسب الحالة",
      averageBookingValue: "متوسط قيمة الحجز",
      averageOrderValue: "متوسط قيمة الطلب",
      cancellationRate: "معدل الإلغاء",
      userMetrics: "مقاييس المستخدمين",
      productMetrics: "مقاييس المنتجات",
      byCategory: "حسب الفئة",
      byBrand: "حسب العلامة التجارية",
      topPerformers: "أفضل الأداء",
      order: "طلب",
      product: "منتج",
      vsPreviousPeriod: "مقارنة بالفترة السابقة",
      // Orders Management
      manageOrders: "إدارة طلبات العملاء",
      pendingPayment: "في انتظار الدفع",
      reviewingPayment: "مراجعة الدفع",
      paid: "مدفوع",
      processing: "قيد المعالجة",
      shipped: "تم الشحن",
      outForDelivery: "في الطريق للتسليم",
      completed: "مكتمل",
      cancelled: "ملغى",
      bankTransfer: "تحويل بنكي",
      cashOnDelivery: "الدفع عند الاستلام",
      online: "عبر الإنترنت",
      receiptStatus: "حالة الإيصال",
      receipt: "الإيصال",
      orderDetails: "تفاصيل الطلب",
      viewOrderInformation: "عرض معلومات الطلب التفصيلية",
      customerInformation: "معلومات العميل",
      itemsSummary: "ملخص العناصر",
      viewReceipt: "عرض الإيصال",
      perPage: "لكل صفحة",
      errorLoadingOrders: "خطأ في تحميل الطلبات",
      noOrdersFound: "لم يتم العثور على طلبات",
      orderId: "رقم الطلب",
      itemsCount: "عدد العناصر",
      itemId: "رقم العنصر",
      quantity: "الكمية",
      subtotal: "المجموع الفرعي",
      allMethods: "جميع الطرق",
      allStatuses: "جميع الحالات",
      date: "التاريخ",
      updateStatus: "تحديث الحالة",
      updateOrderStatus: "تحديث حالة الطلب",
      updateOrderStatusDescription: "تحديث حالة هذا الطلب",
      approveReceipt: "الموافقة على الإيصال",
      rejectReceipt: "رفض الإيصال",
      confirmApproveReceipt: "هل أنت متأكد من الموافقة على هذا الإيصال؟",
      rejectReceiptDescription: "قدم سبب رفض هذا الإيصال",
      orderStatusUpdated: "تم تحديث حالة الطلب بنجاح",
      failedToUpdateOrderStatus: "فشل تحديث حالة الطلب",
      receiptApproved: "تمت الموافقة على الإيصال بنجاح",
      failedToApproveReceipt: "فشل الموافقة على الإيصال",
      receiptRejected: "تم رفض الإيصال بنجاح",
      failedToRejectReceipt: "فشل رفض الإيصال",
      pleaseSelectStatus: "يرجى اختيار الحالة",
      pleaseEnterRemarks: "يرجى إدخال ملاحظات الرفض",
      enterRemarks: "أدخل الملاحظات (اختياري)",
      enterRejectionReason: "أدخل سبب الرفض...",
      remarks: "ملاحظات",
      optional: "اختياري",
      rejecting: "جاري الرفض...",
      openMenu: "فتح القائمة",
      noItems: "لم يتم العثور على عناصر",
      noOrderData: "لا توجد بيانات الطلب متاحة",
      startDate: "تاريخ البداية",
      endDate: "تاريخ النهاية",
      reset: "إعادة تعيين",
      filters: "المرشحات",
      refresh: "تحديث",
      totalAmount: "المبلغ الإجمالي",
      paymentMethod: "طريقة الدفع",
      customer: "العميل",
      address: "العنوان",
      updatedAt: "تم التحديث في",
      price: "السعر",
      selectStatus: "اختر الحالة",
      saving: "جاري الحفظ...",
      to: "إلى",
      showing: "عرض",
      previous: "السابق",
      next: "التالي",
      page: "صفحة",
      of: "من",
      loading: "جاري التحميل",
      success: "نجح",
      error: "خطأ",
      pending: "قيد الانتظار",
      approved: "موافق عليه",
      rejected: "مرفوض",
      product: "المنتج",
      sku: "رمز المنتج",
      currentOccupancy: "الإشغال الحالي",
      latestReviews: "أحدث التقييمات",
      positive: "إيجابي",
      negative: "سلبي",
      satisfaction: "رضا",
      bookingStatusOverview: "نظرة عامة على حالة الحجوزات",
      confirmed: "مؤكدة",
      cancelled: "ملغاة",
      recentBookings: "الحجوزات الحديثة",
      noRecentActivity: "لا يوجد نشاط حديث",
      transactions: "معاملة",
      count: "العدد",
      paymentMethods: "طرق الدفع",
      totalEarningsThisMonth: "إجمالي الأرباح هذا الشهر",
      totalBookings: "إجمالي الحجوزات",
      confirmedReservations: "الحجوزات المؤكدة",
      activeUsers: "المستخدمون النشطون",
      registeredCustomers: "العملاء المسجلون",
      properties: "العقارات",
      listedProperties: "العقارات المدرجة",
      
      // KPI Cards
      vsLastMonth: "مقارنة بالشهر الماضي",
      fromLastMonth: "من الشهر الماضي",
      fromLastWeek: "من الأسبوع الماضي",
      fromYesterday: "من الأمس",
      
      // Charts
      revenueOverview: "نظرة عامة على الإيرادات",
      export: "تصدير",
      bookingStatusDistribution: "توزيع حالة الحجوزات",
      totalBookingsCount: "إجمالي الحجوزات",
      paymentMethods: "طرق الدفع",
      totalAmount: "المبلغ الإجمالي",
      transactions: "المعاملات",
      userGrowthTrends: "اتجاهات نمو المستخدمين",
      newUsers: "مستخدمون جدد",
      activeUsersChart: "المستخدمون النشطون",
      
      // Activity Feed
      recentActivity: "النشاط الحديث",
      newBookingReceived: "تم استلام حجز جديد",
      deluxeSuiteBooked: "تم حجز جناح ديلوكس بواسطة",
      paymentProcessed: "تم معالجة الدفعة",
      paymentReceived: "تم استلام دفعة بقيمة",
      viaMada: "عبر مدى",
      newReviewSubmitted: "تم تقديم مراجعة جديدة",
      fiveStarReview: "مراجعة 5 نجوم لغرفة إطلالة المحيط",
      newUserRegistration: "تسجيل مستخدم جديد",
      joinedPlatform: "انضم إلى المجموعة ",
      propertyUpdated: "تم تحديث العقار",
      beachVillaPhotos: "تم تحديث صور فيلا الشاطئ",
      
      // Time indicators
      minutesAgo: "منذ دقائق",
      hoursAgo: "منذ ساعات",
      
      // Status badges
      success: "نجح",
      warning: "تحذير",
      error: "خطأ",
      info: "معلومات",
      
      // Alerts
      recentAlerts: "التنبيهات الحديثة",
      
      // Bottom metrics
      occupancyRate: "معدل الإشغال",
      avgBookingValue: "متوسط قيمة الحجز",
      customerSatisfaction: "رضا العملاء",
      pendingReviews: "المراجعات المعلقة",
      
      // Controls
      period: "الفترة",
      daily: "يومي",
      weekly: "أسبوعي",
      monthly: "شهري",
      refresh: "تحديث",
      autoRefresh: "التحديث التلقائي",
      saveScreenshot: "حفظ لقطة الشاشة",
      screenshotSaved: "تم حفظ لقطة الشاشة بنجاح",
      savingScreenshot: "جاري حفظ لقطة الشاشة...",
      failedToSaveScreenshot: "فشل حفظ لقطة الشاشة",
      
      // Chart data labels
      confirmed: "مؤكد",
      pending: "معلق",
      completed: "مكتمل",
      cancelled: "ملغي",
      mada: "مدى",
      visa: "فيزا",
      mastercard: "ماستركارد",
      cash: "نقدي",
      
      // Performance indicators
      ofTotal: "من الإجمالي",
      
      // Language indicator for RTL
      language: "ar",
      
      users: "المستخدمون",
      
      // User Management
      manageUsers: "إدارة مستخدمي النظام وصلاحياتهم",
      addUser: "إضافة مستخدم",
      createUser: "إنشاء مستخدم جديد",
      createUserDescription: "إضافة مستخدم جديد إلى النظام",
      editUser: "تعديل المستخدم",
      updateUserInformation: "تحديث معلومات المستخدم",
      viewUserDetails: "عرض تفاصيل المستخدم",
      userDetails: "تفاصيل المستخدم",
      viewUserInformation: "عرض معلومات المستخدم التفصيلية",
      deleteUser: "حذف المستخدم",
      confirmDeleteUser: "هل أنت متأكد من حذف هذا المستخدم؟",
      userDeleted: "تم حذف المستخدم بنجاح",
      userUpdated: "تم تحديث المستخدم بنجاح",
      userCreated: "تم إنشاء المستخدم بنجاح",
      failedToDeleteUser: "فشل في حذف المستخدم",
      failedToUpdateUser: "فشل في تحديث المستخدم",
      failedToCreateUser: "فشل في إنشاء المستخدم",
      
      // User Form Fields
      name: "الاسم",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      password: "كلمة المرور",
      role: "الدور",
      status: "الحالة",
      language: "اللغة",
      registrationDate: "تاريخ التسجيل",
      lastLogin: "آخر تسجيل دخول",
      enterName: "أدخل الاسم الكامل",
      enterEmail: "أدخل عنوان البريد الإلكتروني",
      enterPhone: "أدخل رقم الهاتف",
      enterPassword: "أدخل كلمة المرور",
      selectRole: "اختر الدور",
      selectLanguage: "اختر اللغة",
      
      // User Roles
      customer: "عميل",
      staff: "موظف",
      admin: "مدير",
      superAdmin: "مدير عام",
      
      // User Status
      active: "نشط",
      inactive: "غير نشط",
      suspended: "محظور",
      deleted: "محذوف", 
      
      // User Actions
      block: "حظر",
      activate: "تفعيل",
      deactivate: "إلغاء التفعيل",
      resetPassword: "إعادة تعيين كلمة المرور",
      passwordResetEmailSent: "تم إرسال بريد إعادة تعيين كلمة المرور",
      failedToResetPassword: "فشل في إعادة تعيين كلمة المرور",
      userStatusUpdated: "تم تحديث حالة المستخدم بنجاح",
      failedToUpdateUserStatus: "فشل في تحديث حالة المستخدم",
      failedToRequestPasswordReset: "فشل في طلب إعادة تعيين كلمة المرور",
      sendOTP: "إرسال رمز التحقق",
      otp: "رمز التحقق",
      newPassword: "كلمة المرور الجديدة",
      confirmPassword: "تأكيد كلمة المرور",
      enterOTP: "أدخل رمز التحقق",
      enterNewPassword: "أدخل كلمة المرور الجديدة",
      confirmNewPassword: "أكد كلمة المرور الجديدة",
      passwordsDoNotMatch: "كلمات المرور غير متطابقة",
      pleaseEnterOTP: "يرجى إدخال رمز التحقق",
      pleaseEnterPasswordAndConfirmation: "يرجى إدخال كلمة المرور الجديدة والتأكيد",
      otpSentVia: "تم إرسال رمز التحقق عبر",
      forTestingPurposes: "لأغراض الاختبار",
      otpWillBeSent: "سيتم إرسال رمز التحقق إلى",
      viaSMS: "عبر الرسائل النصية",
      requestOTPToResetPassword: "طلب رمز التحقق لإعادة تعيين كلمة المرور لـ",
      enterOTPAndNewPassword: "أدخل رمز التحقق وكلمة المرور الجديدة لـ",
      id: "الرقم التعريفي",
      passwordResetSuccessful: "تم إعادة تعيين كلمة المرور بنجاح",
      passwordTooShort: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
      
      // Categories
      categoriesManage: "إدارة الفئات",
      totalCategories: "إجمالي الفئات",
      activeCategories: "الفئات النشطة",
      inactiveCategories: "الفئات غير النشطة",
      searchCategories: "البحث في الفئات",
      searchCategoriesPlaceholder: "البحث بالاسم...",
      categoryName: "الاسم",
      categoryNameAr: "الاسم (عربي)",
      categoryIcon: "الأيقونة",
      addCategory: "إضافة فئة",
      editCategory: "تعديل فئة",
      deleteCategory: "حذف فئة",
      categoryCreated: "تم إنشاء الفئة بنجاح",
      categoryUpdated: "تم تحديث الفئة بنجاح",
      categoryDeleted: "تم حذف الفئة بنجاح",
      noCategoriesFound: "لم يتم العثور على فئات",
      categoriesSelected: "فئة محددة",
      organizeProductsCategories: "تنظيم منتجاتك في فئات",
      categoryDetails: "تفاصيل الفئة",
      viewCategoryInformation: "عرض معلومات الفئة التفصيلية",
      viewCategory: "عرض الفئة",
      updateCategoryInformation: "تحديث معلومات الفئة",
      enterCategoryName: "أدخل اسم الفئة",
      enterCategoryNameAr: "أدخل اسم الفئة بالعربية",
      enterIcon: "أدخل اسم الأيقونة",
      confirmDeleteCategory: "هل أنت متأكد من حذف هذه الفئة؟",
      failedToUpdateCategory: "فشل في تحديث الفئة",
      failedToDeleteCategory: "فشل في حذف الفئة",
      productName: "اسم المنتج",
      stock: "المخزون",
      updatedAt: "تم التحديث في",
      
      // Brands
      brandsManage: "إدارة العلامات التجارية",
      totalBrands: "إجمالي العلامات التجارية",
      activeBrands: "العلامات التجارية النشطة",
      inactiveBrands: "العلامات التجارية غير النشطة",
      searchBrands: "البحث في العلامات التجارية",
      searchBrandsPlaceholder: "البحث بالاسم...",
      brandName: "الاسم",
      brandNameAr: "الاسم (عربي)",
      brandLogo: "الشعار",
      brandLogoUrl: "رابط الشعار",
      addBrand: "إضافة علامة تجارية",
      createBrand: "إنشاء علامة تجارية",
      createNewBrand: "إنشاء علامة تجارية جديدة",
      editBrand: "تعديل علامة تجارية",
      deleteBrand: "حذف علامة تجارية",
      brandCreated: "تم إنشاء العلامة التجارية بنجاح",
      brandUpdated: "تم تحديث العلامة التجارية بنجاح",
      brandDeleted: "تم حذف العلامة التجارية بنجاح",
      noBrandsFound: "لم يتم العثور على علامات تجارية",
      brandsSelected: "علامة تجارية محددة",
      manageBrands: "إدارة العلامات التجارية للمنتجات",
      brandDetails: "تفاصيل العلامة التجارية",
      viewBrandInformation: "عرض معلومات العلامة التجارية التفصيلية",
      viewBrand: "عرض العلامة التجارية",
      updateBrandInformation: "تحديث معلومات العلامة التجارية",
      enterBrandName: "أدخل اسم العلامة التجارية",
      enterBrandNameAr: "أدخل اسم العلامة التجارية بالعربية",
      enterLogoUrl: "أدخل رابط الشعار",
      confirmDeleteBrand: "هل أنت متأكد من حذف هذه العلامة التجارية؟",
      failedToCreateBrand: "فشل في إنشاء العلامة التجارية",
      failedToUpdateBrand: "فشل في تحديث العلامة التجارية",
      failedToDeleteBrand: "فشل في حذف العلامة التجارية",
      
      // Products
      productsManage: "إدارة المنتجات",
      manageProducts: "إدارة منتجاتك",
      addProduct: "إضافة منتج",
      searchProductsPlaceholder: "البحث بالاسم، رمز SKU...",
      noProductsFound: "لم يتم العثور على منتجات",
      productDetails: "تفاصيل المنتج",
      viewProductInformation: "عرض معلومات المنتج التفصيلية",
      viewProduct: "عرض المنتج",
      editProduct: "تعديل المنتج",
      deleteProduct: "حذف المنتج",
      productName: "الاسم",
      sku: "رمز المنتج",
      barcode: "الباركود",
      price: "السعر",
      currency: "جنيه",
      description: "الوصف",
      productImages: "صور المنتج",
      rating: "التقييم",
      featured: "مميز",
      sortBy: "ترتيب حسب",
      selectSort: "اختر الترتيب",
      newest: "الأحدث",
      popular: "الأكثر شعبية",
      priceLowToHigh: "السعر: من الأقل للأعلى",
      priceHighToLow: "السعر: من الأعلى للأقل",
      selectCategory: "اختر الفئة",
      allCategories: "جميع الفئات",
      selectBrand: "اختر العلامة التجارية",
      allBrands: "جميع العلامات التجارية",
      
      // Product Create/Edit
      createNewProduct: "إنشاء منتج جديد",
      updateProductInformation: "تحديث معلومات المنتج",
      productCreated: "تم إنشاء المنتج بنجاح",
      productUpdated: "تم تحديث المنتج بنجاح",
      failedToCreateProduct: "فشل في إنشاء المنتج",
      failedToUpdateProduct: "فشل في تحديث المنتج",
      enterProductName: "أدخل اسم المنتج",
      enterProductNameAr: "أدخل اسم المنتج بالعربية",
      productNameAr: "الاسم (عربي)",
      descriptionAr: "الوصف (عربي)",
      discountPrice: "سعر الخصم",
      enterSku: "أدخل رمز المنتج",
      enterBarcode: "أدخل الباركود",
      enterDescription: "أدخل الوصف",
      enterDescriptionAr: "أدخل الوصف بالعربية",
      thumbnailUrl: "رابط الصورة المصغرة",
      enterThumbnailUrl: "أدخل رابط الصورة المصغرة",
      addImage: "إضافة صورة",
      enterImageUrl: "أدخل رابط الصورة",
      creating: "جاري الإنشاء...",
      pleaseCompleteAllRequiredFields: "يرجى إكمال جميع الحقول المطلوبة",
      productDeleted: "تم حذف المنتج بنجاح",
      failedToDeleteProduct: "فشل في حذف المنتج",
      confirmDeleteProduct: "هل أنت متأكد من حذف هذا المنتج؟",
      productStatusUpdated: "تم تحديث حالة المنتج بنجاح",
      failedToUpdateProductStatus: "فشل في تحديث حالة المنتج",
      productStockUpdated: "تم تحديث مخزون المنتج بنجاح",
      failedToUpdateProductStock: "فشل في تحديث مخزون المنتج",
      updateStock: "تحديث المخزون",
      updateProductStock: "تحديث كمية المخزون لهذا المنتج",
      pleaseEnterValidStock: "يرجى إدخال رقم مخزون صالح",
      
      // User Statistics
      totalUsers: "إجمالي المستخدمين",
      activeUsers: "المستخدمون النشطون",
      blockedUsers: "المستخدمون المحظورون",
      adminUsers: "المستخدمون المديرون",
      
      // User Table
      contact: "جهة الاتصال",
      actions: "الإجراءات",
      view: "عرض",
      edit: "تعديل",
      delete: "حذف",
      openMenu: "فتح القائمة",
      
      // User Search & Filters
      search: "بحث",
      searchUsers: "البحث بالاسم أو رقم الهاتف أو البريد الإلكتروني",
      searchUsersPlaceholder: "البحث بالاسم أو البريد الإلكتروني أو الهاتف...",
      filterByRole: "تصفية حسب الدور",
      filterByStatus: "تصفية حسب الحالة",
      searchAndFilters: "البحث والتصفية",
      allRoles: "جميع الأدوار",
      allStatuses: "جميع الحالات",
      selectStatus: "اختر الحالة",
      pageSize: "عناصر لكل صفحة",
      refresh: "تحديث",
      usersSelected: "مستخدم محدد",
      
      // User Bulk Actions
      selectedUsersCount: "تم تحديد {{count}} مستخدم",
      clearSelection: "إلغاء التحديد",
      bulkActions: "الإجراءات المجمعة",
      bulkActivate: "تفعيل المحددين",
      bulkBlock: "حظر المحددين",
      bulkDelete: "حذف المحددين",
      bulkOperationCompleted: "تمت العملية المجمعة بنجاح",
      bulkOperationFailed: "فشلت العملية المجمعة",
      noUsersSelected: "لم يتم تحديد مستخدمين",
      pleaseSelectUsers: "يرجى تحديد مستخدمين لتنفيذ الإجراءات المجمعة",
      
      // User Export/Import
      export: "تصدير",
      exportCSV: "تصدير كـ CSV",
      exportExcel: "تصدير كـ Excel",
      exportStarted: "بدأ التصدير",
      downloadWillStartShortly: "سيبدأ التحميل قريباً",
      exportFailed: "فشل التصدير",
      
      // User Pagination
      showing: "عرض",
      of: "من",
      previous: "السابق",
      next: "التالي",
      
      // User Validation
      validationError: "خطأ في التحقق",
      pleaseCompleteAllFields: "يرجى إكمال جميع الحقول المطلوبة",
      noChanges: "لا توجد تغييرات",
      noChangesToSave: "لا توجد تغييرات للحفظ",
      
      // General
      success: "نجح",
      error: "خطأ",
      loading: "جاري التحميل",
      cancel: "إلغاء",
      save: "حفظ",
      saveChanges: "حفظ التغييرات",
      creating: "جاري الإنشاء",
      saving: "جاري الحفظ",
      close: "إغلاق",
      never: "أبداً",
      unknown: "غير معروف",
      noUsersFound: "لم يتم العثور على مستخدمين",
      
      // Property Types Management
      propertyTypes: "أنواع العقارات",
      managePropertyTypes: "إدارة أنواع العقارات المختلفة في النظام",
      addPropertyType: "إضافة نوع عقار",
      createPropertyType: "إنشاء نوع عقار",
      createPropertyTypeDescription: "إضافة نوع عقار جديد إلى النظام",
      editPropertyType: "تعديل نوع العقار",
      updatePropertyTypeInformation: "تحديث معلومات نوع العقار",
      propertyTypeDetails: "تفاصيل نوع العقار",
      viewPropertyTypeInformation: "عرض معلومات نوع العقار التفصيلية",
      deletePropertyType: "حذف نوع العقار",
      propertyTypeCreated: "تم إنشاء نوع العقار بنجاح",
      propertyTypeUpdated: "تم تحديث نوع العقار بنجاح",
      propertyTypeDeleted: "تم حذف نوع العقار بنجاح",
      propertyTypeStatusUpdated: "تم تحديث حالة نوع العقار",
      failedToCreatePropertyType: "فشل في إنشاء نوع العقار",
      failedToUpdatePropertyType: "فشل في تحديث نوع العقار",
      failedToDeletePropertyType: "فشل في حذف نوع العقار",
      failedToUpdateStatus: "فشل في تحديث الحالة",
      
      // Property Type Fields
      nameEnglish: "الاسم (إنجليزي)",
      nameArabic: "الاسم (عربي)",
      descriptionEnglish: "الوصف (إنجليزي)",
      descriptionArabic: "الوصف (عربي)",
      enterDescriptionEnglish: "أدخل الوصف باللغة الإنجليزية",
      enterDescriptionArabic: "أدخل الوصف باللغة العربية",
      icon: "الأيقونة",
      selectIcon: "اختر الأيقونة",
      
      // Property Type Statistics
      totalTypes: "إجمالي الأنواع",
      activeTypes: "الأنواع النشطة",
      inactiveTypes: "الأنواع غير النشطة",
      
      // Property Type Actions
      deactivate: "إلغاء التفعيل",
      bulkDeactivate: "إلغاء تفعيل المحددة",
      noPropertyTypesFound: "لم يتم العثور على أنواع عقارات",
      searchPropertyTypes: "البحث في أنواع العقارات...",
      typesSelected: "أنواع محددة",
      noTypesSelected: "لم يتم تحديد أنواع",
      pleaseSelectTypes: "يرجى تحديد أنواع العقارات",
      
      // Property Type Status & Dates
      created: "تم الإنشاء",
      lastUpdated: "آخر تحديث",
      
      reviews: "المراجعات",
      reviewsManagement: "إدارة المراجعات",
      manageHotelReviewsAndRatings: "إدارة مراجعات وتقييمات الفنادق",
      addReview: "إضافة مراجعة",
      addNewReview: "إضافة مراجعة جديدة",
      createNewReviewForHotel: "إنشاء مراجعة جديدة لفندق.",
      averageRating: "متوسط التقييم",
      acrossAllReviews: "عبر جميع المراجعات",
      approvedReviews: "المراجعات المعتمدة",
      pendingReviews: "المراجعات المعلقة",
      awaitingApproval: "في انتظار الموافقة",
      allReviews: "جميع المراجعات",
      searchReviews: "البحث في المراجعات...",
      editReview: "تعديل المراجعة",
      updateReviewInformationAndStatus: "تحديث معلومات المراجعة والحالة.",
      user: "المستخدم",
      rating: "التقييم",
      title: "العنوان",
      helpful: "مفيد",
      date: "التاريخ",
      approved: "معتمد",
      pending: "معلق",
      rejected: "مرفوض",
      hotelName: "اسم الفندق",
      userName: "اسم المستخدم",
      reviewTitle: "عنوان المراجعة",
      reviewComment: "تعليق المراجعة",
      hotelResponse: "رد الفندق",
      optionalHotelResponse: "رد اختياري من الفندق...",
      createReview: "إنشاء مراجعة",
      updateReview: "تحديث المراجعة",
      reviewCreatedSuccessfully: "تم إنشاء المراجعة بنجاح",
      reviewUpdatedSuccessfully: "تم تحديث المراجعة بنجاح",
      failedToCreateReview: "فشل في إنشاء المراجعة",
      failedToUpdateReview: "فشل في تحديث المراجعة",

      deleteReview: "حذف المراجعة",
      confirmDeleteReview: "هل أنت متأكد من أنك تريد حذف هذه المراجعة؟ لا يمكن التراجع عن هذا الإجراء.",
      reviewDeleted: "تم حذف المراجعة بنجاح",
      failedToDeleteReview: "فشل في حذف المراجعة",
      viewReview: "عرض المراجعة",
      reviewDetails: "تفاصيل المراجعة",
      reviewInformation: "معلومات المراجعة",
      reviewResponse: "رد المراجعة",
      helpfulVotes: "الأصوات المفيدة",
      notHelpfulVotes: "الأصوات غير المفيدة",
      totalVotes: "إجمالي الأصوات",
      reviewStatus: "حالة المراجعة",
      reviewDate: "تاريخ المراجعة",
      noReviewsFound: "لم يتم العثور على مراجعات",
      failedToLoadReviews: "فشل في تحميل المراجعات",
      star: "نجمة",
      stars: "نجوم",
      payments: "المدفوعات",
      support: "الدعم",
      revenue: "الإيرادات",
      settings: "الإعدادات",
      logout: "تسجيل الخروج",

      // User Roles
      customer: "عميل",
      admin: "مدير",
      staff: "موظف",
      user: "مستخدم",

      // Extended Navigation
      analytics: "التحليلات",
      drivers: "السائقون",
      riders: "الركاب",
      vehicles: "المركبات",
      trips: "الرحلات",
      complaints: "الشكاوى",
      cities: "المدن",
      notifications: "الإشعارات",
      guests: "النزلاء",
      housekeeping: "التدبير المنزلي",

      // Additional Common
      approve: "موافقة",
      reject: "رفض",
      yes: "نعم",
      no: "لا",
      confirm: "تأكيد",
      send: "إرسال",
      schedule: "جدولة",
      notFound: "الصفحة غير موجودة",

      // Login & Authentication
      signIn: "تسجيل الدخول",
      phoneNumber: "رقم الهاتف",
      saudiPhoneFormat: "تنسيق الهاتف السعودي: +966XXXXXXXXX",
      password: "كلمة المرور",
      enterPassword: "أدخل كلمة المرور",
      loginSuccessful: "تم تسجيل الدخول بنجاح",
      loginFailed: "فشل تسجيل الدخول",
      invalidCredentials: "بيانات اعتماد غير صحيحة",
      validationError: "خطأ في التحقق",
      phoneAndPasswordRequired: "رقم الهاتف وكلمة المرور مطلوبان",
      loading: "جاري التحميل...",

      // Dashboard
      totalHotels: "عدد الفنادق الشريكة",
      activeHotels: "الفنادق النشطة",
      todayBookings: "حجوزات اليوم",
      monthlyRevenue: "الإيرادات الشهرية",
      availableRooms: "الغرف المتاحة",
      weeklyRevenue: "الإيرادات الأسبوعية",
      dailyRevenue: "الإيرادات اليومية",
      
      // Quick Actions
      addNewRoom: "إضافة غرفة جديدة",
      manageCoupons: "إدارة الكوبونات",
      checkReviews: "فحص المراجعات",
      quickActions: "الإجراءات السريعة",
      
      // Charts
      bookingTrends: "اتجاهات الحجز",
      paymentMethods: "طرق الدفع",
      occupancyByRoomType: "الإشغال حسب نوع الغرفة",
      weeklyBookings: "الحجوزات الأسبوعية",
      dailyBookings: "الحجوزات اليومية",
      revenueDistribution: "توزيع الإيرادات",
      
      // Activity Feed
      bookingCancellation: "إلغاء حجز",
      roomAdded: "تم إضافة غرفة",
      
      // Notifications
      lowAvailability: "توفر منخفض",
      systemAlert: "تنبيه النظام",
      onlyRoomsLeft: "باقي {{count}} غرفة {{type}} فقط لـ {{date}}",
      reviewsAwaitingApproval: "{{count}} مراجعة في انتظار الموافقة",
      paymentGatewayError: "تم اكتشاف خطأ في بوابة الدفع",
      apiIssue: "مشكلة في الاتصال بـ API",
      
      // Dashboard specific text
      overview: "نظرة عامة",
      overviewHotelManagement: "نظرة عامة على أداء مجموعة  إدارة الفنادق الخاصة بك",
      roomsAvailable: "غرف متاحة",
      newReservationsToday: "حجوزات جديدة اليوم",
      fromLastMonth: "من الشهر الماضي",
      newReservations: "حجوزات جديدة",
      fromLastWeek: "من الأسبوع الماضي",
      fromYesterday: "من أمس",
      fromLastMonthRating: "من الشهر الماضي",
      
      // Room types
      deluxe: "ديلوكس",
      standard: "عادي",
      family: "عائلي",
      
      // Activity messages
      newBookingDeluxe: "حجز جديد لغرفة ديلوكس",
      newReviewSubmitted: "مراجعة جديدة من أحمد الراشد",
      paymentReceived: "تم استلام دفعة للحجز رقم 1234",
      bookingCancelled: "تم إلغاء الحجز رقم 1230",
      couponUsed: "تم استخدام كوبون 'SUMMER20'",
      minutesAgo: "دقائق مضت",
      hoursAgo: "ساعات مضت",
      
      // Notification messages
      onlyDeluxeRoomLeft: "باقي غرفة ديلوكس واحدة فقط لـ 5 سبتمبر",
      reviewsAwaitingApprovalCount: "3 مراجعات في انتظار الموافقة",
      paymentGatewayRestored: "تم استعادة اتصال بوابة الدفع",

      // Common
      hotel: "الفندق",
      search: "بحث",
      filter: "تصفية",
      status: "الحالة",
      actions: "الإجراءات",
      edit: "تعديل",
      delete: "حذف",
      view: "عرض",
      add: "إضافة",
      save: "حفظ",
      cancel: "إلغاء",
      noData: "لا توجد بيانات",

      // Auth
      welcome: "مرحباً",
      welcomeToBadeelAlawal: "مرحباً بك في  مجموعة  إعمار للادوات الصحية!",

      // Bookings
      bookingManagement: "إدارة الحجوزات",
      addBooking: "إضافة حجز",
      editBooking: "تعديل الحجز",
      createBooking: "إنشاء حجز",
      bookingDetails: "تفاصيل الحجز",
      allBookings: "جميع الحجوزات",
      newUser: "مستخدم جديد",
      existingUser: "مستخدم موجود",
      userName: "اسم المستخدم",
      userPhone: "رقم الهاتف",
      enterUserName: "أدخل اسم المستخدم",
      enterUserPhone: "أدخل رقم الهاتف",
      pleaseFillUserFields: "يرجى ملء اسم المستخدم ورقم الهاتف",
      phoneRequiredWhenNoUser: "رقم الهاتف مطلوب عند عدم اختيار مستخدم",
      pleaseSelectUser: "يرجى اختيار مستخدم",
      creatingUser: "جاري إنشاء حساب المستخدم...",
      userCreatedSuccessfully: "تم إنشاء حساب المستخدم بنجاح",
      failedToCreateUser: "فشل في إنشاء حساب المستخدم",
      paymentPageOpened: "تم فتح صفحة الدفع في نافذة جديدة",
      popupBlocked: "تم حظر النافذة المنبثقة. يرجى السماح بالنوافذ المنبثقة",
      verifyingPayment: "جاري التحقق من الدفع...",
      paymentSuccessful: "تم الدفع بنجاح",
      paymentFailed: "فشل الدفع",
      paymentVerifiedSuccessfully: "تم التحقق من الدفع بنجاح",
      paymentVerificationFailed: "فشل التحقق من الدفع",
      missingPaymentParameters: "معاملات الدفع مفقودة",
      redirectingToBookings: "سيتم إعادة التوجيه إلى صفحة الحجوزات...",
      goToBookings: "العودة إلى الحجوزات",
      smsSentTo: "تم إرسال رسالة نصية إلى",
      smsNotSent: "لم يتم إرسال الرسالة النصية. يرجى التحقق من إعدادات SMS",
      smsSentToCustomerCompletePayment: "تم إرسال رسالة للعميل، يرجى إكمال عملية الدفع",
      manageHotelReservationsAndBookings: "إدارة حجوزات الفنادق والحجوزات",
      createNewHotelReservation: "إنشاء حجز فندق جديد",
      viewBookingInformation: "عرض معلومات الحجز",
      bookingCreatedSuccessfully: "تم إنشاء الحجز بنجاح",
      bookingCancelledSuccessfully: "تم إلغاء الحجز بنجاح",
      failedToCreateBooking: "فشل في إنشاء الحجز",
      failedToCancelBooking: "فشل في إلغاء الحجز",
      failedToDeleteBooking: "فشل في حذف الحجز",
      bookingDeletedSuccessfully: "تم حذف الحجز بنجاح",
      confirmDeleteBooking: "هل أنت متأكد من حذف هذا الحجز؟ لا يمكن التراجع عن هذا الإجراء.",
      refund: "استرداد",
      enterRefundReason: "أدخل سبب الاسترداد:",
      confirmRefundBooking: "هل أنت متأكد من استرداد هذا الحجز؟",
      bookingRefundedSuccessfully: "تم استرداد الحجز بنجاح",
      failedToRefundBooking: "فشل في استرداد الحجز",
      failedToLoadBookings: "فشل في تحميل الحجوزات",
      failedToLoadBookingDetails: "فشل في تحميل تفاصيل الحجز",
      failedToExportBookings: "فشل في تصدير الحجوزات",
      bookingsExportedSuccessfully: "تم تصدير الحجوزات بنجاح",
      paymentPending: "دفع معلق",
      propertyInformation: "معلومات العقار",
      financialDetails: "التفاصيل المالية",
      bookingMetadata: "بيانات الحجز",
      additionalInformation: "معلومات إضافية",
      couponApplied: "تم تطبيق كوبون",
      bookingStatus: "حالة الحجز",
      bookingDates: "تواريخ الحجز",
      originalAmount: "المبلغ الأصلي",
      discountAmount: "مبلغ الخصم",
      finalAmount: "المبلغ النهائي",
      depositAmount: "مبلغ العربون",
      depositPaid: "العربون المدفوع",
      remainingAmount: "المبلغ المتبقي",
      specialRequests: "طلبات خاصة",
      notes: "ملاحظات",
      userId: "معرف المستخدم",
      propertyId: "معرف العقار",
      createdAt: "تاريخ الإنشاء",
      lastUpdated: "آخر تحديث",
      paymentReference: "مرجع الدفع",
      bookingNotFound: "لم يتم العثور على الحجز",
      guests: "عدد الضيوف",
      selectReason: "اختر السبب",
      payment: "الدفع",
      twilioProvider: "تويليو",
      unifonicProvider: "يونيفونيك",
      checkConsoleForDetails: "تحقق من وحدة التحكم للحصول على التفاصيل",
      currentRole: "الدور الحالي",
      filterByUser: "فلترة حسب المستخدم",
      filterByProperty: "فلترة حسب العقار",
      changeStatus: "تغيير الحالة",
      changeBookingStatus: "تغيير حالة الحجز",
      changeBookingStatusDescription: "اختر الحالة الجديدة للحجز. لا يمكن التراجع عن هذا الإجراء.",
      currentStatus: "الحالة الحالية",
      newStatus: "الحالة الجديدة",
      selectNewStatus: "اختر الحالة الجديدة",
      cancellationReason: "سبب الإلغاء",
      customReason: "سبب مخصص",
      enterCustomReason: "أدخل السبب المخصص",
      cancelReasonRequired: "سبب الإلغاء مطلوب",
      bookingStatusUpdated: "تم تحديث حالة الحجز بنجاح",
      failedToUpdateBookingStatus: "فشل في تحديث حالة الحجز",
      customerRequest: "طلب العميل",
      propertyUnavailable: "العقار غير متاح",
      emergency: "حالة طوارئ",
      paymentFailed: "فشل الدفع",
      maintenance: "صيانة",
      other: "أخرى",
      updating: "جاري التحديث...",
      updateStatus: "تحديث الحالة",
      cancelBooking: "إلغاء الحجز",
      
      bookingId: "رقم الحجز",
      property: "العقار",
      checkInDate: "تاريخ الوصول",
      checkOutDate: "تاريخ المغادرة",
      guestCount: "عدد الضيوف",
      paymentMethod: "طريقة الدفع",
      couponCode: "كود الخصم",
      enterCouponCode: "أدخل كود الخصم",
      specialRequests: "طلبات خاصة",
      enterSpecialRequests: "أدخل الطلبات الخاصة",
      paymentSummary: "ملخص الدفع",
      totalAmount: "المبلغ الإجمالي",
      depositRequired: "العربون المطلوب",
      remainingAmount: "المبلغ المتبقي",
      depositPercentage: "العربون: {{percentage}}%",
      depositNote: "يجب دفع 30٪ كعربون عند الحجز، والباقي يُدفع عند تسجيل الوصول.",
      depositExplanation: "العربون مطلوب لجميع الحجوزات بغض النظر عن الكوبونات. هذا يضمن حجزك.",
      noDepositNote: "الدفع الكامل مطلوب عند الحجز. لا حاجة لعربون.",
      couponDiscount: "خصم الكوبون",
      selectProperty: "اختر العقار",
      selectStatus: "اختر الحالة",
      selectPaymentMethod: "اختر طريقة الدفع",
      searchPaymentMethods: "البحث عن طرق الدفع",
      failedToLoadPaymentMethods: "فشل في تحميل طرق الدفع",
      noPaymentMethods: "لا توجد طرق دفع متاحة",
      usingMockPaymentMethods: "استخدام طرق دفع تجريبية",
      canceled: "ملغي",
      completed: "مكتمل",
      dateFrom: "من تاريخ",
      dateTo: "إلى تاريخ",
      clearFilters: "مسح المرشحات",
      exportCSV: "تصدير CSV",
      exportExcel: "تصدير Excel",
      searchBookings: "البحث في الحجوزات...",
      filters: "المرشحات",
      createdOn: "تم الإنشاء في",
      bookingInformation: "معلومات الحجز",
      paymentInformation: "معلومات الدفع",
      customerInformation: "معلومات العميل",
      depositPaid: "العربون المدفوع",
      customerName: "اسم العميل",
      customerEmail: "بريد العميل الإلكتروني",
      customerPhone: "هاتف العميل",
      createNewUserAccount: "إنشاء حساب مستخدم جديد.",
      updateUserInformationAndStatus: "تحديث معلومات المستخدم والحالة.",
      viewUserInformation: "عرض معلومات المستخدم.",
      customerLanguage: "لغة العميل",
      pastBookings: "الحجوزات السابقة",
      customerAverageRating: "متوسط تقييم العميل",
      couponUsedStatus: "كوبون مستخدم",
      confirmedBookings: "الحجوزات المؤكدة",
      allTimeBookings: "جميع الحجوزات",
      activeReservations: "الحجوزات النشطة",
      fromAllBookings: "من جميع الحجوزات",
      pendingDeposits: "العربونات المعلقة",
      awaitingPayment: "في انتظار الدفع",
      bookingNotFound: "الحجز غير موجود",

      // Hotels

      // Payments
      paymentManagement: "إدارة المدفوعات",

      // Users
      addUser: "إضافة مستخدم",
      editUser: "تعديل المستخدم",
      deleteUser: "حذف المستخدم",
      viewUser: "عرض المستخدم",
      userDetails: "تفاصيل المستخدم",
      createUser: "إنشاء مستخدم",
      updateUser: "تحديث المستخدم",
      userCreatedSuccessfully: "تم إنشاء المستخدم بنجاح",
      userUpdatedSuccessfully: "تم تحديث المستخدم بنجاح",
      userDeletedSuccessfully: "تم حذف المستخدم بنجاح",
      failedToCreateUser: "فشل في إنشاء المستخدم",
      failedToUpdateUser: "فشل في تحديث المستخدم",
      failedToDeleteUser: "فشل في حذف المستخدم",
      confirmDeleteUser: "هل أنت متأكد من حذف هذا المستخدم؟ لا يمكن التراجع عن هذا الإجراء.",
      userNotFound: "المستخدم غير موجود",
      activeUsers: "المستخدمون النشطون",
      inactiveUsers: "المستخدمون غير النشطين",
      suspendedUsers: "المستخدمون المعلقون",
      newUsers: "مستخدمون جدد",
      userRole: "دور المستخدم",
      userStatus: "حالة المستخدم",
      joinDate: "تاريخ الانضمام",
      lastLogin: "آخر تسجيل دخول",
      regular: "عادي",
      userAvatar: "صورة المستخدم",
      userProfile: "ملف المستخدم",
      userActivity: "نشاط المستخدم",
      userPermissions: "صلاحيات المستخدم",
      userSettings: "إعدادات المستخدم",
      filterByRole: "تصفية حسب الدور",
      filterByStatus: "تصفية حسب الحالة",
      allRoles: "جميع الأدوار",
      userStatistics: "إحصائيات المستخدمين",
      userAnalytics: "تحليلات المستخدمين",
      userReports: "تقارير المستخدمين",
      exportUsers: "تصدير المستخدمين",
      importUsers: "استيراد المستخدمين",
      bulkActions: "إجراءات مجمعة",
      selectAll: "تحديد الكل",
      deselectAll: "إلغاء تحديد الكل",
      bulkDelete: "حذف مجمع",
      bulkUpdate: "تحديث مجمع",
      userGroups: "مجموعات المستخدمين",
      userCategories: "فئات المستخدمين",
      userTags: "علامات المستخدمين",
      userNotes: "ملاحظات المستخدم",
      userComments: "تعليقات المستخدم",
      userHistory: "تاريخ المستخدم",
      userLogs: "سجلات المستخدم",
      userAudit: "تدقيق المستخدم",
      
      // Status Values
      
      // Static Content Management
      staticContentManagement: "إدارة المحتوى الثابت",
      manageStaticContent: "إدارة المحتوى الثابت",
      staticcontent: "الصفحات الثابتة والمعلومات",
      aboutUsPage: "صفحة من نحن",
      contactInformation: "معلومات الاتصال",
      galleryPhotos: "صور المعرض",
      legalPages: "الصفحات القانونية",
      privacyPolicy: "سياسة الخصوصية",
      termsConditions: "الشروط والأحكام",
      contentPreview: "معاينة المحتوى",
      richTextEditor: "محرر النصوص الغني",
      uploadPhotos: "رفع الصور",
      editContent: "تعديل المحتوى",
      saveChanges: "حفظ التغييرات",
      publishChanges: "نشر التغييرات",
      previewChanges: "معاينة التغييرات",
      versionHistory: "تاريخ الإصدارات",
      contentVersioning: "إصدارات المحتوى",
      livePreview: "معاينة مباشرة",
      mobilePreview: "معاينة الهاتف المحمول",
      printPreview: "معاينة الطباعة",
      bilingualSupport: "دعم اللغتين",
      rtlSupport: "دعم الكتابة من اليمين لليسار",
      ltrSupport: "دعم الكتابة من اليسار لليمين",
      
      // Content Management Actions
      addNewContent: "إضافة محتوى جديد",
      deleteContent: "حذف المحتوى",
      duplicateContent: "نسخ المحتوى",
      moveContent: "نقل المحتوى",
      copyContent: "نسخ المحتوى",
      archiveContent: "أرشفة المحتوى",
      restoreContent: "استعادة المحتوى",
      publishContent: "نشر المحتوى",
      unpublishContent: "إلغاء نشر المحتوى",
      schedulePublish: "جدولة النشر",
      contentStatus: "حالة المحتوى",
      draft: "مسودة",
      published: "منشور",
      archived: "مؤرشف",
      
      // Rich Text Editor
      bold: "عريض",
      italic: "مائل",
      underline: "تسطير",
      strikethrough: "خط في المنتصف",
      alignLeft: "محاذاة لليسار",
      alignCenter: "محاذاة للوسط",
      alignRight: "محاذاة لليمين",
      alignJustify: "محاذاة مبررة",
      insertLink: "إدراج رابط",
      insertImage: "إدراج صورة",
      insertList: "إدراج قائمة",
      insertOrderedList: "إدراج قائمة مرقمة",
      insertUnorderedList: "إدراج قائمة نقطية",
      undo: "تراجع",
      redo: "إعادة",
      clearFormatting: "مسح التنسيق",
      textColor: "لون النص",
      backgroundColor: "لون الخلفية",
      fontSize: "حجم الخط",
      fontFamily: "نوع الخط",
      
      // Contact Information
      emailAddress: "عنوان البريد الإلكتروني",
      whatsappNumber: "رقم الواتساب",
      physicalAddress: "العنوان الفعلي",
      socialMedia: "وسائل التواصل الاجتماعي",
      website: "الموقع الإلكتروني",
      businessHours: "ساعات العمل",
      contactType: "نوع الاتصال",
      contactValue: "قيمة الاتصال",
      contactLabel: "تسمية الاتصال",
      displayOrder: "ترتيب العرض",
      isActive: "نشط",
      addContactInfo: "إضافة معلومات الاتصال",
      editContactInfo: "تعديل معلومات الاتصال",
      deleteContactInfo: "حذف معلومات الاتصال",
      
      // Gallery Management
      imageUpload: "رفع الصور",
      dragDropImages: "اسحب وأفلت الصور هنا",
      selectImages: "اختر الصور",
      imageMetadata: "بيانات الصورة",
      altText: "النص البديل",
      imageCaption: "تعليق الصورة",
      imageCategory: "فئة الصورة",
      imageTags: "علامات الصورة",
      imageSize: "حجم الصورة",
      imageFormat: "تنسيق الصورة",
      imageDimensions: "أبعاد الصورة",
      uploadProgress: "تقدم الرفع",
      uploadComplete: "اكتمل الرفع",
      uploadFailed: "فشل الرفع",
      maxFileSize: "الحد الأقصى لحجم الملف",
      allowedFormats: "التنسيقات المسموحة",
      imageOptimization: "تحسين الصور",
      thumbnailGeneration: "إنشاء الصور المصغرة",
      imageCompression: "ضغط الصور",
      
      // Content Types
      textContent: "محتوى نصي",
      htmlContent: "محتوى HTML",
      markdownContent: "محتوى Markdown",
      plainText: "نص عادي",
      formattedText: "نص منسق",
      mediaContent: "محتوى وسائط",
      embeddedContent: "محتوى مدمج",
      dynamicContent: "محتوى ديناميكي",
      staticContent: "محتوى ثابت",
      
      // Validation Messages
      contentRequired: "المحتوى مطلوب",
      titleRequired: "العنوان مطلوب",
      contentTooShort: "المحتوى قصير جداً",
      contentTooLong: "المحتوى طويل جداً",
      invalidFormat: "تنسيق غير صحيح",
      fileTooLarge: "الملف كبير جداً",
      unsupportedFileType: "نوع ملف غير مدعوم",
      uploadError: "حدث خطأ في الرفع",
      saveError: "حدث خطأ في الحفظ",
      loadError: "حدث خطأ في التحميل",
      networkError: "حدث خطأ في الشبكة",
      
      // Success Messages
      contentSaved: "تم حفظ المحتوى بنجاح",
      contentPublished: "تم نشر المحتوى بنجاح",
      contentDeleted: "تم حذف المحتوى بنجاح",
      contentUpdated: "تم تحديث المحتوى بنجاح",
      contentCreated: "تم إنشاء المحتوى بنجاح",
      imageUploaded: "تم رفع الصورة بنجاح",
      contactInfoAdded: "تم إضافة معلومات الاتصال بنجاح",
      contactInfoUpdated: "تم تحديث معلومات الاتصال بنجاح",
      contactInfoDeleted: "تم حذف معلومات الاتصال بنجاح",
      
      // Additional Static Content Translations
      manageContactInformation: "إدارة معلومات الاتصال",
      addNewContactInformation: "إضافة معلومات اتصال جديدة",
      updateContactInformation: "تحديث معلومات الاتصال",
      enterContactValue: "أدخل قيمة الاتصال",
      enterArabicLabel: "أدخل التسمية العربية",
      enterEnglishLabel: "أدخل التسمية الإنجليزية",
      manageGalleryImages: "إدارة صور المعرض",
      uploadNewImagesToGallery: "رفع صور جديدة للمعرض",
      orClickToSelectFiles: "أو انقر لاختيار الملفات",
      searchImages: "البحث في الصور",
      allCategories: "جميع الفئات",
      apartments: "الشقق",
      amenities: "المرافق",
      location: "الموقع",
      searchLocation: "البحث عن موقع...",
      useCurrentLocation: "استخدام الموقع الحالي",
      selectedLocation: "الموقع المحدد",
      coordinates: "الإحداثيات",
      cityOrRegion: "المدينة أو المنطقة",
      events: "الأحداث",
      editImage: "تعديل الصورة",
      deleteImage: "حذف الصورة",
      downloadImage: "تحميل الصورة",
      updateImageMetadata: "تحديث بيانات الصورة",
      viewLiveSite: "عرض الموقع المباشر",
      fullScreen: "ملء الشاشة",
      desktop: "سطح المكتب",
      mobile: "الهاتف المحمول",
      print: "الطباعة",
      home: "الرئيسية",
      aboutUs: "من نحن",
      contact: "اتصل بنا",
      gallery: "المعرض",
      selectPageToPreview: "اختر صفحة للمعاينة",
      allRightsReserved: "جميع الحقوق محفوظة",
      language: "اللغة",
      direction: "الاتجاه",
      lastUpdated: "آخر تحديث",
      activate: "تفعيل",
      deactivate: "إلغاء التفعيل",
      
      // Contact Management Additional Translations
      viewContactInfo: "عرض معلومات الاتصال",
      viewContactInformation: "عرض تفاصيل معلومات الاتصال",
      contactStatistics: "إحصائيات الاتصال",
      activeStatus: "حالة النشاط",
      close: "إغلاق",
      confirmDeleteContact: "هل أنت متأكد من حذف معلومات الاتصال هذه؟ لا يمكن التراجع عن هذا الإجراء.",

      // Language
      systemLanguage: "اللغة",
      english: "English",
      arabic: "العربية",
      switchLanguage: "تبديل اللغة",

      // Room Management
      rooms: "عقارات",
      roomManagement: "إدارة العقارات",
      propertyTypes: "أنواع العقارات",
      createPropertyType: "إنشاء نوع عقار",
      updatePropertyType: "تحديث نوع العقار",
      deletePropertyType: "حذف نوع العقار",
      seedPropertyTypes: "إضافة أنواع العقارات الافتراضية",
      propertyTypeName: "اسم نوع العقار",
      propertyTypeDescription: "وصف نوع العقار",
      propertyTypeIcon: "أيقونة نوع العقار",
      
      // Property Management
      createProperty: "إنشاء عقار",
      updateProperty: "تحديث العقار",
      deleteProperty: "حذف العقار",
      propertyName: "اسم العقار",
      propertyDescription: "وصف العقار",
      propertyType: "نوع العقار",
      address: "العنوان",
      latitude: "خط العرض",
      longitude: "خط الطول",
      fullPrice: "السعر الكامل",
      depositType: "نوع العربون",
      depositValue: "قيمة العربون",
      capacity: "السعة",
      bedrooms: "غرف النوم",
      bathrooms: "دورات المياه",
      checkInTime: "وقت تسجيل الوصول",
      checkOutTime: "وقت تسجيل المغادرة",
      media: "الوسائط",
      featured: "مميز",
      
      // Property Types
      apartment: "شقة",
      suite: "جناح",
      luxuryRoom: "غرفة فاخرة",
      villa: "فيلا",
      studio: "استوديو",
      
      // Property Type Management
      viewPropertyType: "عرض نوع العقار",
      editPropertyType: "تعديل نوع العقار",
      confirmDeletePropertyType: "هل أنت متأكد من حذف نوع العقار هذا؟",
      propertyTypeDeleted: "تم حذف نوع العقار بنجاح",
      propertyTypeCreated: "تم إنشاء نوع العقار بنجاح",
      propertyTypeUpdated: "تم تحديث نوع العقار بنجاح",
      noPropertyTypes: "لم يتم العثور على أنواع عقارات",
      addFirstPropertyType: "أضف أول نوع عقار",
      
      // Property Type Form
      englishInformation: "المعلومات الإنجليزية",
      arabicInformation: "المعلومات العربية",
      nameEnglish: "الاسم (إنجليزي)",
      nameArabic: "الاسم (عربي)",
      descriptionEnglish: "الوصف (إنجليزي)",
      descriptionArabic: "الوصف (عربي)",
      
      // Property Type View
      propertyTypeInformation: "معلومات نوع العقار",
      englishName: "الاسم الإنجليزي",
      arabicName: "الاسم العربي",
      englishDescription: "الوصف الإنجليزي",
      arabicDescription: "الوصف العربي",
      statistics: "الإحصائيات",
      properties: "العقارات",
      activeBookings: "الحجوزات النشطة",
      totalRevenue: "إجمالي الإيرادات",
      metadata: "البيانات الوصفية",
      createdAt: "تاريخ الإنشاء",
      
      // Property Management
      confirmDeleteProperty: "هل أنت متأكد من حذف هذا العقار؟ لا يمكن التراجع عن هذا الإجراء.",
      propertyDeleted: "تم حذف العقار بنجاح",
      propertyCreated: "تم إنشاء العقار بنجاح",
      propertyUpdated: "تم تحديث العقار بنجاح",
      noProperties: "لم يتم العثور على عقارات",
      addFirstProperty: "أضف أول عقار",
      managePropertyInventory: "إدارة مخزون العقارات وأنواع الغرف",
      failedToDeletePropertyType: "فشل في حذف نوع العقار.",
      failedToDeleteProperty: "فشل في حذف العقار.",
      
      // Amenities
      wifi: "واي فاي",
      parking: "موقف سيارات",
      kitchen: "مطبخ",
      airConditioning: "تكييف هواء",
      swimmingPool: "مسبح",
      gym: "صالة رياضية",
      spa: "سبا",
      restaurant: "مطعم",
      roomService: "خدمة الغرف",
      laundry: "غسيل ملابس",
      balcony: "شرفة",
      seaView: "إطلالة بحرية",
      cityView: "إطلالة على المدينة",
      
      // Deposit Types
      fixed: "ثابت",
      percentage: "نسبة مئوية",
      
      // Media Management
      uploadMedia: "رفع وسائط",
      mediaFiles: "ملفات الوسائط",
      primaryImage: "الصورة الأساسية",
      mediaTitle: "عنوان الوسائط",
      mediaDescription: "وصف الوسائط",
      selectFiles: "اختيار الملفات",
      dragDropFiles: "اسحب وأفلت الملفات هنا، أو انقر للاختيار",
      removeMedia: "إزالة الوسائط",
      setAsPrimary: "تعيين كصورة أساسية",
      mediaUploaded: "تم رفع الوسائط بنجاح",
      mediaRemoved: "تم إزالة الوسائط بنجاح",
      primaryImageSet: "تم تعيين الصورة الأساسية بنجاح",
      supportedFormats: "الصيغ المدعومة: JPG, PNG, GIF, MP4, MOV",
      mediaDetails: "تفاصيل الوسائط",
      
      // Room Statistics
      roomStats: "إحصائيات الغرف",
      totalProperties: "إجمالي العقارات",
      activeProperties: "العقارات النشطة",
      occupancyRate: "معدل الإشغال",
      topPerformingTypes: "أفضل الأنواع أداءً",
      averagePrice: "متوسط السعر",
      
      // Filters and Search
      minPrice: "الحد الأدنى للسعر",
      maxPrice: "الحد الأقصى للسعر",
      availableOnly: "المتاح فقط",
      sortBy: "ترتيب حسب",
      sortOrder: "ترتيب",
      ascending: "تصاعدي",
      descending: "تنازلي",
      price: "السعر",
      sortByName: "اسم العقار",
      updatedAt: "تاريخ التحديث",

      // =========== الكوبونات ===========
      coupons: "الكوبونات",
      couponsTitle: "إدارة الكوبونات",
      couponsSubtitle: "إنشاء وإدارة كوبونات الخصم",
      createCoupon: "إنشاء كوبون",
      editCoupon: "تعديل الكوبون",
      deleteCoupon: "حذف الكوبون",
        couponName: "اسم الكوبون",
        discountType: "نوع الخصم",
        discountValue: "قيمة الخصم",
        fixedAmount: "مبلغ ثابت",
      minOrderAmount: "الحد الأدنى للطلب",
      maxDiscountAmount: "الحد الأقصى للخصم",
      usageLimit: "حد الاستخدام",
      validFrom: "صالح من",
      validUntil: "صالح حتى",
      totalUsage: "إجمالي الاستخدام",
      remainingUsage: "الاستخدام المتبقي",
      couponStats: "إحصائيات الكوبونات",
      totalCoupons: "إجمالي الكوبونات",
      activeCoupons: "الكوبونات النشطة",
      expiredCoupons: "الكوبونات المنتهية",
      searchCoupons: "البحث بكود الكوبون أو الوصف...",
      exportCoupons: "تصدير الكوبونات",
      filtered: "مفلتر",
      showing: "عرض",
      of: "من",
      noCoupons: "لم يتم العثور على كوبونات",
      amount: "مبلغ",
      flat: "ثابت",
      duplicateCouponCode: "يوجد كوبون بهذا الكود بالفعل",
      editCoupon: "تعديل الكوبون",
      editCouponDescription: "تحديث تفاصيل الكوبون",
      
      // إدارة التقييمات
      reviews: "التقييمات",
      reviewsSubtitle: "إدارة تقييمات وتقديرات العملاء",
      totalReviews: "إجمالي التقييمات",
      pendingReviews: "التقييمات المعلقة",
      approvedReviews: "التقييمات المعتمدة",
      rejectedReviews: "التقييمات المرفوضة",
      featuredReviews: "التقييمات المميزة",
      averageRating: "متوسط التقييم",
      searchReviews: "البحث بالتعليق أو المستخدم أو العقار...",
      allRatings: "جميع التقييمات",
      allReviews: "جميع التقييمات",
      notFeatured: "غير مميز",
      reviewsList: "قائمة التقييمات",
      manageReviews: "إدارة تقييمات وتقديرات العملاء",
      noReviews: "لم يتم العثور على تقييمات",
      noReviewsMatch: "لا توجد تقييمات تطابق المرشحات الحالية",
      customer: "العميل",
      property: "العقار",
      rating: "التقييم",
      comment: "التعليق",
      featured: "مميز",
      date: "التاريخ",
      actions: "الإجراءات",
      reviewDetails: "تفاصيل التقييم",
      viewReviewDetails: "عرض معلومات مفصلة حول هذا التقييم",
      booking: "الحجز",
      yes: "نعم",
      no: "لا",
      pending: "معلق",
      approved: "معتمد",
      rejected: "مرفوض",
      deleteReview: "حذف التقييم",
      deleteReviewConfirmation: "هل أنت متأكد من حذف هذا التقييم؟ لا يمكن التراجع عن هذا الإجراء.",
      reviewUpdatedSuccessfully: "تم تحديث التقييم بنجاح",
      reviewDeletedSuccessfully: "تم حذف التقييم بنجاح",
      reviewFeaturedToggled: "تم تحديث حالة التقييم المميز",
      addReview: "إضافة تقييم",
      addReviewDescription: "إنشاء تقييم جديد للحجز",
      bookingId: "رقم الحجز",
      bookingIdRequired: "رقم الحجز مطلوب",
      commentRequired: "التعليق مطلوب",
      ratingInvalid: "يجب أن يكون التقييم بين 1 و 5",
      enterComment: "أدخل تعليق التقييم...",
      mediaUrls: "روابط الوسائط (اختياري)",
      enterMediaUrls: "أدخل روابط الوسائط، رابط واحد في كل سطر:",
      mediaUrlsHelp: "أدخل رابط واحد في كل سطر. اتركه فارغاً إذا لم تكن هناك وسائط.",
      createReview: "إنشاء تقييم",
      creating: "جاري الإنشاء...",
      reviewCreatedSuccessfully: "تم إنشاء التقييم بنجاح",
      
      // إدارة معاملات الدفع
      payments: "المدفوعات",
      paymentTransactions: "معاملات الدفع",
      paymentTransactionsTitle: "معاملات الدفع",
      paymentTransactionsSubtitle: "عرض وإدارة جميع معاملات الدفع",
      paymentLogs: "سجلات الدفع",
      viewAllTransactionInformation: "عرض جميع معلومات المعاملة والبيانات ذات الصلة",
      transactionInformation: "معلومات المعاملة",
      internalTransactionId: "رقم المعاملة الداخلي",
      gatewayOrderId: "رقم طلب البوابة",
      gatewaySessionId: "رقم جلسة البوابة",
      processedAt: "تم المعالجة في",
      errorMessage: "رسالة الخطأ",
      providerName: "اسم طريقة الدفع",
      merchantId: "رقم التاجر",
      bookingInformation: "معلومات الحجز",
      bookingStatus: "حالة الحجز",
      checkIn: "تاريخ الوصول",
      checkOut: "تاريخ المغادرة",
      totalPrice: "السعر الإجمالي",
      depositAmount: "مبلغ العربون",
      guestCount: "عدد الضيوف",
      specialRequests: "طلبات خاصة",
      userInformation: "معلومات المستخدم",
      gatewayResponse: "رد البوابة",
      bookingMetadata: "بيانات الحجز",
      webhookData: "بيانات Webhook",
      providerLogs: "سجلات طريقة الدفع",
      providerLogsTitle: "سجلات طريقة الدفع",
      providerLogsSubtitle: "عرض سجلات وردود API لطريقة الدفع",
      transactionDetails: "تفاصيل المعاملة",
      transactionId: "رقم المعاملة",
      bookingId: "رقم الحجز",
      userId: "رقم المستخدم",
      providerCode: "طريقة الدفع",
      paymentMethod: "طريقة الدفع",
      amount: "المبلغ",
      status: "الحالة",
      createdAt: "تاريخ الإنشاء",
      updatedAt: "آخر تحديث",
      transactionStatus: "حالة المعاملة",
      paymentState: "حالة الدفع",
      internalOrderState: "حالة الطلب الداخلية",
      actionRequired: "إجراء مطلوب",
      notes: "ملاحظات",
      providerResponse: "رد طريقة الدفع",
      viewDetails: "عرض التفاصيل",
      capture: "تحصيل",
      cancel: "إلغاء",
      refund: "استرداد",
      reconcile: "مطابقة",
      captureTransaction: "تحصيل المعاملة",
      cancelTransaction: "إلغاء المعاملة",
      refundTransaction: "استرداد المعاملة",
      refundDescription: "أدخل تفاصيل الاسترداد. سيتم معالجة استرداد للمعاملة.",
      referenceId: "رقم المرجع",
      enterReferenceId: "أدخل رقم المرجع (مفتاح عدم التكرار)",
      referenceIdDescription: "معرف فريد لطلب الاسترداد هذا",
      enterRefundReason: "أدخل سبب الاسترداد",
      reconcileTransaction: "مطابقة المعاملة",
      captureAmount: "مبلغ التحصيل",
      refundAmount: "مبلغ الاسترداد",
      enterAmount: "أدخل المبلغ",
      amountRequired: "المبلغ مطلوب",
      amountMustBePositive: "يجب أن يكون المبلغ موجباً",
      amountExceedsTransaction: "المبلغ يتجاوز مبلغ المعاملة",
      defaultToFullAmount: "اتركه فارغاً لاستخدام المبلغ الكامل للمعاملة",
      confirmCapture: "هل أنت متأكد من تحصيل هذه المعاملة؟",
      confirmCancel: "هل أنت متأكد من إلغاء هذه المعاملة؟",
      confirmRefund: "هل أنت متأكد من استرداد هذه المعاملة؟",
      transactionCaptured: "تم تحصيل المعاملة بنجاح",
      transactionCancelled: "تم إلغاء المعاملة بنجاح",
      transactionRefunded: "تم استرداد المعاملة بنجاح",
      transactionReconciled: "تم مطابقة المعاملة بنجاح",
      failedToCapture: "فشل تحصيل المعاملة",
      failedToCancel: "فشل إلغاء المعاملة",
      failedToRefund: "فشل استرداد المعاملة",
      failedToReconcile: "فشل مطابقة المعاملة",
      failedToLoadTransactions: "فشل تحميل المعاملات",
      failedToLoadTransaction: "فشل تحميل تفاصيل المعاملة",
      failedToLoadLogs: "فشل تحميل السجلات",
      noTransactionsFound: "لم يتم العثور على معاملات",
      noLogsFound: "لم يتم العثور على سجلات",
      logDetails: "تفاصيل السجل",
      viewAllLogInformation: "عرض جميع معلومات السجل بما في ذلك بيانات الطلب والاستجابة",
      basicInformation: "المعلومات الأساسية",
      logId: "معرف السجل",
      paymentMethodId: "معرف طريقة الدفع",
      requestType: "نوع الطلب",
      requestUrl: "رابط الطلب",
      requestBody: "نص الطلب",
      responseBody: "نص الاستجابة",
      statusCode: "رمز الحالة",
      executionTime: "وقت التنفيذ",
      context: "السياق",
      gatewayOrderId: "رقم طلب البوابة",
      gatewaySessionId: "رقم جلسة البوابة",
      allRequestTypes: "جميع أنواع الطلبات",
      allStatusCodes: "جميع رموز الحالة",
      success: "نجح",
      loadingTransactions: "جاري تحميل المعاملات...",
      loadingTransaction: "جاري تحميل تفاصيل المعاملة...",
      loadingLogs: "جاري تحميل السجلات...",
      filterByProvider: "فلترة حسب طريقة الدفع",
      filterByStatus: "فلترة حسب الحالة",
      filterByBooking: "فلترة حسب الحجز",
      filterByUser: "فلترة حسب المستخدم",
      filterByDate: "فلترة حسب التاريخ",
      dateFrom: "من تاريخ",
      dateTo: "إلى تاريخ",
      amountMin: "الحد الأدنى للمبلغ",
      amountMax: "الحد الأقصى للمبلغ",
      clearFilters: "مسح الفلاتر",
      applyFilters: "تطبيق الفلاتر",
      searchTransactions: "البحث في المعاملات...",
      searchLogs: "البحث في السجلات...",
      allProviders: "جميع طرق الدفع",
      allStatuses: "جميع الحالات",
      transactionStatusPending: "معلق",
      transactionStatusAuthorized: "مصرح",
      transactionStatusPaid: "مدفوع",
      transactionStatusRefunded: "مسترد",
      transactionStatusCancelled: "ملغي",
      transactionStatusFailed: "فاشل",
      showingResults: "عرض",
      to: "إلى",
      of: "من",
      results: "نتيجة",
      page: "الصفحة",
      next: "التالي",
      previous: "السابق",
      itemsPerPage: "عناصر في الصفحة",
      booking: "الحجز",
      user: "المستخدم",
      provider: "طريقة الدفع",
      method: "الطريقة",
      totalAmount: "المبلغ الإجمالي",
      transactionDate: "تاريخ المعاملة",
      lastUpdated: "آخر تحديث",
      viewTransaction: "عرض المعاملة",
      backToList: "العودة إلى المعاملات",
      transactionInformation: "معلومات المعاملة",
      relatedInformation: "معلومات ذات صلة",
      bookingInformation: "معلومات الحجز",
      userInformation: "معلومات المستخدم",
      paymentMethodInformation: "معلومات طريقة الدفع",
      actionResults: "نتائج الإجراء",
      step: "الخطوة",
      responseStatus: "حالة الرد",
      responseData: "بيانات الرد",
      noResponseData: "لا توجد بيانات رد متاحة",
      expandResponse: "توسيع الرد",
      collapseResponse: "طي الرد",
      logLevel: "مستوى السجل",
      logMessage: "الرسالة",
      logTimestamp: "الطابع الزمني",
      logRequest: "الطلب",
      logResponse: "الرد",
      filterByLevel: "فلترة حسب المستوى",
      allLevels: "جميع المستويات",
      info: "معلومات",
      error: "خطأ",
      warning: "تحذير",
      debug: "تصحيح",
      youDoNotHavePermission: "ليس لديك صلاحية لعرض معاملات الدفع.",
      youDoNotHavePermissionToEdit: "ليس لديك صلاحية لتنفيذ هذا الإجراء.",
      
      // إدارة الصفحات الثابتة
      staticContent: "المحتوى الثابت",
      staticContentSubtitle: "إدارة الصفحات والمحتوى الثابت",
      addPage: "إضافة صفحة",
      totalPages: "إجمالي الصفحات",
      activePages: "الصفحات النشطة",
      inactivePages: "الصفحات غير النشطة",
      searchPages: "البحث بالعنوان أو الرابط أو المحتوى...",
      pagesList: "قائمة الصفحات",
      managePages: "إدارة الصفحات والمحتوى الثابت",
      noPages: "لم يتم العثور على صفحات",
      noPagesMatch: "لا توجد صفحات تطابق المرشحات الحالية",
      createFirstPage: "إنشاء أول صفحة",
      title: "العنوان",
      slug: "الرابط",
      lastUpdated: "آخر تحديث",
      editPage: "تعديل الصفحة",
      editPageDescription: "تحديث محتوى وإعدادات الصفحة",
      addPageDescription: "إنشاء صفحة ثابتة جديدة",
      titleEnglish: "العنوان (إنجليزي)",
      titleArabic: "العنوان (عربي)",
      contentEnglish: "المحتوى (إنجليزي)",
      contentArabic: "المحتوى (عربي)",
      slugHelp: "معرف صديق للرابط (مثل: privacy-policy)",
      htmlSupported: "علامات HTML مدعومة",
      updatePage: "تحديث الصفحة",
      createPage: "إنشاء صفحة",
      saving: "جاري الحفظ...",
      pageDetails: "تفاصيل الصفحة",
      viewPageDetails: "عرض معلومات مفصلة حول هذه الصفحة",
      deletePage: "حذف الصفحة",
      deletePageConfirmation: "هل أنت متأكد من حذف هذه الصفحة؟ لا يمكن التراجع عن هذا الإجراء.",
      pageCreatedSuccessfully: "تم إنشاء الصفحة بنجاح",
      pageUpdatedSuccessfully: "تم تحديث الصفحة بنجاح",
      pageDeletedSuccessfully: "تم حذف الصفحة بنجاح",
      pageStatusUpdated: "تم تحديث حالة الصفحة",
      titleArRequired: "العنوان العربي مطلوب",
      titleEnRequired: "العنوان الإنجليزي مطلوب",
      slugRequired: "الرابط مطلوب",
      duplicateSlug: "يوجد صفحة بهذا الرابط بالفعل",

      // Payment Methods Management
      paymentMethods: "طرق الدفع",
      paymentMethodsList: "قائمة طرق الدفع",
      addPaymentMethod: "إضافة طريقة دفع",
      editPaymentMethod: "تعديل طريقة الدفع",
      paymentMethodDetails: "تفاصيل طريقة الدفع",
      totalMethods: "إجمالي الطرق",
      activeMethods: "الطرق النشطة",
      inactiveMethods: "الطرق غير النشطة",
      searchPaymentMethods: "البحث في طرق الدفع...",
      noPaymentMethods: "لا توجد طرق دفع",
      noPaymentMethodsMatch: "لا توجد طرق دفع تطابق معايير البحث",
      createFirstPaymentMethod: "أنشئ طريقة الدفع الأولى",
      provider: "المزود",
      providerName: "اسم المزود",
      providerCode: "كود المزود",
      providerLogo: "شعار المزود",
      code: "الكود",
      displayOrder: "ترتيب العرض",
      imageUrl: "رابط الصورة",
      publicKey: "المفتاح العام",
      secretKey: "المفتاح السري",
      merchantId: "معرف التاجر",
      callbackUrl: "رابط الاستدعاء",
      enterProviderName: "أدخل اسم طريقة الدفع",
      enterProviderCode: "أدخل كود طريقة الدفع",
      enterImageUrl: "أدخل رابط الصورة",
      enterPublicKey: "أدخل المفتاح العام",
      enterSecretKey: "أدخل المفتاح السري",
      enterMerchantId: "أدخل معرف التاجر",
      enterCallbackUrl: "أدخل رابط الاستدعاء",
      createPaymentMethod: "إنشاء طريقة دفع",
      updatePaymentMethod: "تحديث طريقة الدفع",
      deletePaymentMethod: "حذف طريقة الدفع",
      deletePaymentMethodConfirmation: "هل أنت متأكد من حذف طريقة الدفع هذه؟ لا يمكن التراجع عن هذا الإجراء.",
      paymentMethodCreatedSuccessfully: "تم إنشاء طريقة الدفع بنجاح",
      paymentMethodUpdatedSuccessfully: "تم تحديث طريقة الدفع بنجاح",
      paymentMethodDeletedSuccessfully: "تم حذف طريقة الدفع بنجاح",
      paymentMethodStatusToggled: "تم تحديث حالة طريقة الدفع بنجاح",
      failedToCreatePaymentMethod: "فشل في إنشاء طريقة الدفع",
      failedToUpdatePaymentMethod: "فشل في تحديث طريقة الدفع",
      failedToDeletePaymentMethod: "فشل في حذف طريقة الدفع",
      failedToTogglePaymentMethodStatus: "فشل في تحديث حالة طريقة الدفع",
      providerNameRequired: "اسم طريقة الدفع مطلوب",
      providerCodeRequired: "كود طريقة الدفع مطلوب",
      descriptionRequired: "الوصف مطلوب",
      allStatuses: "جميع الحالات",
      createdAt: "تاريخ الإنشاء",
      paymentMethodsEndpointNotAvailable: "خدمة طرق الدفع غير متاحة",
      paymentMethodsEndpointNotImplemented: "نقاط النهاية الخاصة بواجهة برمجة التطبيقات لطرق الدفع لم يتم تنفيذها بعد على الخادم الخلفي. يرجى تنفيذ نقاط النهاية المطلوبة لتمكين إدارة طرق الدفع.",
      requiredEndpoints: "نقاط النهاية المطلوبة لواجهة برمجة التطبيقات",
      retryConnection: "إعادة المحاولة",
      testApi: "اختبار واجهة برمجة التطبيقات",
      testGetApi: "اختبار GET API",
      testToggleApi: "اختبار Toggle API",
      
      // General & Notification Settings
      generalAndNotifications: "الإعدادات العامة والإشعارات",
      smsProviderSettings: "إعدادات مزود الرسائل النصية",
      smsProviderConfiguration: "تكوين مزود خدمة الرسائل النصية للإشعارات",
      smsApiKey: "مفتاح API للرسائل النصية",
      enterSmsApiKey: "أدخل مفتاح API للرسائل النصية",
      senderId: "معرف المرسل",
      enterSenderId: "أدخل معرف المرسل",
      firebaseSettings: "إعدادات Firebase",
      firebaseConfiguration: "تكوين Firebase للإشعارات الفورية",
      firebaseServerKey: "مفتاح خادم Firebase",
      enterFirebaseServerKey: "أدخل مفتاح خادم Firebase",
      pushNotifications: "الإشعارات الفورية",
      pushNotificationsDesc: "إرسال الإشعارات الفورية عبر Firebase",
      blocked: "محظور",
      saveAllSettings: "حفظ جميع الإعدادات",
      settingUpdatedSuccessfully: "تم تحديث الإعداد بنجاح",
      settingsUpdatedSuccessfully: "تم تحديث الإعدادات بنجاح",
      failedToUpdateSetting: "فشل في تحديث الإعداد",
      failedToUpdateSettings: "فشل في تحديث الإعدادات",
      createSetting: "إنشاء إعداد",
      createSettingDescription: "إضافة إعداد نظام جديد",
      settingCreatedSuccessfully: "تم إنشاء الإعداد بنجاح",
      failedToCreateSetting: "فشل في إنشاء الإعداد",
      key: "المفتاح",
      value: "القيمة",
      group: "المجموعة",
      description: "الوصف",
      encryptValue: "تشفير القيمة",
      enterSettingKey: "أدخل مفتاح الإعداد",
      enterSettingValue: "أدخل قيمة الإعداد",
      enterSettingDescription: "أدخل وصف الإعداد",
      keyRequired: "المفتاح مطلوب",
      valueRequired: "القيمة مطلوبة",
      invalidKeyFormat: "تنسيق المفتاح غير صحيح",
      keyFormatDescription: "يجب أن يحتوي المفتاح على أحرف وأرقام وشرطات سفلية فقط",
      general: "عام",
      sms: "رسائل نصية",
      firebase: "فايربيس",
      email: "بريد إلكتروني",
      creating: "جاري الإنشاء...",
      manageSettings: "إدارة الإعدادات",
      manageSettingsDescription: "عرض وإدارة جميع إعدادات النظام",
      allGroups: "جميع المجموعات",
      encrypted: "مشفر",
      lastUpdated: "آخر تحديث",
      noValue: "لا توجد قيمة",
      noDescription: "لا يوجد وصف",
      noSettings: "لا توجد إعدادات",
      noSettingsDescription: "لم يتم العثور على إعدادات. قم بإنشاء أول إعداد للبدء.",
      createFirstSetting: "إنشاء أول إعداد",
      settingsLoadError: "فشل في تحميل الإعدادات",
      settingsLoadErrorDescription: "حدث خطأ أثناء تحميل بيانات الإعدادات.",
      retry: "إعادة المحاولة",
      deleteNotImplemented: "الحذف غير متاح",
      deleteSettingNotImplemented: "وظيفة حذف الإعدادات غير مطبقة بعد.",
      editSetting: "تعديل الإعداد",
      editSettingDescription: "تحديث قيمة الإعداد والوصف",
      updateSetting: "تحديث الإعداد",
      updating: "جاري التحديث...",
      keyCannotBeChanged: "لا يمكن تغيير المفتاح عند التعديل",
      groupCannotBeChanged: "لا يمكن تغيير المجموعة عند التعديل",
      cannotBeChanged: "لا يمكن تغييره",
      settingDeletedSuccessfully: "تم حذف الإعداد بنجاح",
      failedToDeleteSetting: "فشل في حذف الإعداد",
      confirmDeleteSetting: "هل أنت متأكد من حذف الإعداد '{{key}}'؟ لا يمكن التراجع عن هذا الإجراء.",
      showingResults: "عرض {{start}} إلى {{end}} من {{total}} نتيجة",
      itemsPerPage: "عناصر لكل صفحة",
      previous: "السابق",
      next: "التالي",
      roles: "الأدوار",
      rolesDescription: "إدارة أدوار المستخدمين وصلاحياتهم",
      createRole: "إنشاء دور",
      rolesComingSoon: "إدارة الأدوار قريباً",
      rolesComingSoonDescription: "سيتم تطبيق وظائف إدارة الأدوار هنا.",
      permissions: "الصلاحيات",
      permissionsDescription: "إدارة صلاحيات النظام والتحكم في الوصول",
      createPermission: "إنشاء صلاحية",
      permissionsComingSoon: "إدارة الصلاحيات قريباً",
      permissionsComingSoonDescription: "سيتم تطبيق وظائف إدارة الصلاحيات هنا.",
      
      // Notifications System
      notifications: "الإشعارات",
      myNotifications: "إشعاراتي",
      adminNotifications: "إشعارات المدير",
      manageYourNotifications: "إدارة الإشعارات والتفضيلات الخاصة بك",
      manageAndSendNotifications: "إدارة وإرسال الإشعارات للمستخدمين",
      totalNotifications: "إجمالي الإشعارات",
      unreadNotifications: "الإشعارات غير المقروءة",
      readNotifications: "الإشعارات المقروءة",
      markAsRead: "تحديد كمقروء",
      markAllAsRead: "تحديد الكل كمقروء",
      deleteNotification: "حذف الإشعار",
      deleteNotificationConfirmation: "هل أنت متأكد من حذف هذا الإشعار؟ لا يمكن التراجع عن هذا الإجراء.",
      searchNotifications: "البحث في الإشعارات...",
      allTypes: "جميع الأنواع",
      read: "مقروء",
      unread: "غير مقروء",
      noNotifications: "لا توجد إشعارات",
      noNotificationsMatch: "لا توجد إشعارات تطابق معاييرك",
      youWillSeeNotificationsHere: "ستظهر إشعاراتك هنا عند استلامها",
      tryAdjustingYourFilters: "جرب تعديل مرشحات البحث",
      viewAllNotifications: "عرض جميع الإشعارات",
      
      // Notification Settings
      notificationSettings: "إعدادات الإشعارات",
      configureYourNotificationPreferences: "تكوين تفضيلات الإشعارات الخاصة بك",
      emailNotifications: "إشعارات البريد الإلكتروني",
      smsNotifications: "إشعارات الرسائل النصية",
      notificationTypes: "أنواع الإشعارات",
      bookingUpdates: "تحديثات الحجوزات",
      promotions: "العروض الترويجية",
      systemUpdates: "تحديثات النظام",
      enableBrowserNotifications: "تفعيل إشعارات المتصفح لتلقي التحديثات الفورية",
      enableNotifications: "تفعيل الإشعارات",
      
      // Notification Types
      booking: "حجز",
      promotion: "عرض ترويجي",
      review: "مراجعة",
      systemUpdate: "تحديث النظام",
      payment: "دفع",
      general: "عام",
      
      // Admin Notifications
      sendNotification: "إرسال إشعار",
      bulkNotifications: "الإشعارات المجمعة",
      statistics: "الإحصائيات",
      sendNotificationToSpecificUsers: "إرسال إشعار لمستخدمين محددين",
      sendNotificationToMultipleUsers: "إرسال إشعار لعدة مستخدمين بناءً على المرشحات",
      userIds: "معرفات المستخدمين",
      enterUserIds: "أدخل معرفات المستخدمين (مفصولة بفواصل)",
      separateUserIdsWithCommas: "افصل معرفات المستخدمين المتعددة بفواصل",
      notificationType: "نوع الإشعار",
      enterNotificationTitle: "أدخل عنوان الإشعار",
      message: "الرسالة",
      enterNotificationMessage: "أدخل رسالة الإشعار",
      deliveryChannels: "قنوات التسليم",
      pushNotification: "إشعار فوري",
      email: "بريد إلكتروني",
      sms: "رسالة نصية",
      sending: "جاري الإرسال...",
      reset: "إعادة تعيين",
      
      // Bulk Notifications
      userRole: "دور المستخدم",
      selectRole: "اختر الدور",
      allRoles: "جميع الأدوار",
      customer: "عميل",
      driver: "سائق",
      staff: "موظف",
      admin: "مدير",
      userStatus: "حالة المستخدم",
      lastActiveAfter: "آخر نشاط بعد",
      sendBulkNotification: "إرسال إشعار مجمع",
      
      // Notification Stats
      notificationStatistics: "إحصائيات الإشعارات",
      viewDetailedNotificationStats: "عرض إحصائيات الإشعارات التفصيلية والتحليلات",
      totalSent: "إجمالي المرسل",
      totalDelivered: "إجمالي المسلم",
      totalRead: "إجمالي المقروء",
      totalClicked: "إجمالي النقرات",
      deliveryRate: "معدل التسليم",
      readRate: "معدل القراءة",
      clickRate: "معدل النقر",
      startDate: "تاريخ البداية",
      endDate: "تاريخ النهاية",
      applyFilters: "تطبيق المرشحات",
      loadingStats: "جاري تحميل الإحصائيات...",
      byType: "حسب النوع",
      byChannel: "حسب القناة",
      noDataAvailable: "لا توجد بيانات متاحة",
      noUsersFound: "لا يوجد مستخدمون",
      noUsersDescription: "لا يوجد مستخدمون متاحون في الوقت الحالي.",
      noPropertiesFound: "لا توجد خصائص",
      noPropertiesDescription: "لا توجد خصائص متاحة في الوقت الحالي.",
      noBookingsFound: "لا توجد حجوزات",
      noBookingsDescription: "لا توجد حجوزات متاحة في الوقت الحالي.",
      noSettingsFound: "لا توجد إعدادات",
      propertyTypes: "أنواع العقارات",
      typeArabic: "النوع (عربي)",
      avgPrice: "متوسط السعر",
      topPerformingProperties: "أفضل العقارات أداءً",
      recentBookings: "الحجوزات الحديثة",
      count: "العدد",
      lastSignup: "آخر تسجيل",
      financialSummary: "الملخص المالي",
      allTimeRevenue: "إجمالي الإيرادات",
      pendingPayments: "المدفوعات المعلقة",
      awaitingPayment: "في انتظار الدفع",
      refundsIssued: "المبالغ المستردة",
      totalRefunds: "إجمالي المبالغ المستردة",
      commissionEarned: "العمولة المكتسبة",
      platformCommission: "عمولة المجموعة ",
      systemInformation: "معلومات النظام",
      systemUptime: "وقت تشغيل النظام",
      serverUptime: "وقت تشغيل الخادم",
      minutes: "دقيقة",
      lastUpdate: "آخر تحديث",
      dataLastUpdated: "آخر تحديث للبيانات",
      registeredUsers: "المستخدمون المسجلون",
      listedProperties: "العقارات المدرجة",
      noAnalyticsData: "لا توجد بيانات تحليلية متاحة في الوقت الحالي.",
      noPaymentData: "لا توجد بيانات طرق دفع متاحة في الوقت الحالي.",
      userDistribution: "توزيع المستخدمين",
      usersByRole: "المستخدمون حسب الدور",
      propertyTypesDistribution: "توزيع أنواع العقارات",
      propertiesByType: "العقارات حسب النوع",
      financialOverview: "نظرة عامة مالية",
      revenueAndExpenses: "الإيرادات والمصروفات",
      noUserData: "لا توجد بيانات المستخدمين متاحة في الوقت الحالي.",
      noPropertyData: "لا توجد بيانات العقارات متاحة في الوقت الحالي.",
      noFinancialData: "لا توجد بيانات مالية متاحة في الوقت الحالي.",
      
      // Additional Translations
      searchAndFilters: "البحث والمرشحات",
      couponsList: "قائمة الكوبونات",
      sendNotificationToUsers: "إرسال إشعار للمستخدمين",
      notificationChannels: "قنوات الإشعارات",
      mailNotification: "إشعار البريد الإلكتروني",
      smsProvider: "مزود الرسائل النصية",
      enableSmsNotifications: "تفعيل إشعارات الرسائل النصية",
      configurePlatformSettings: "تكوين إعدادات المجموعة ",
      badeel: " مجموعة  إعمار للادوات الصحية",
      servicedApartments: "لوحة إدارة التجارة الإلكترونية",
      
      // Success/Error Messages
      notificationSentSuccessfully: "تم إرسال الإشعار بنجاح",
      notificationHasBeenSent: "تم إرسال الإشعار للمستخدمين المحددين",
      bulkNotificationSentSuccessfully: "تم إرسال الإشعار المجمع بنجاح",
      bulkNotificationHasBeenSent: "تم إرسال الإشعار المجمع للمستخدمين المطابقين",
      failedToSendNotification: "فشل في إرسال الإشعار",
      failedToSendBulkNotification: "فشل في إرسال الإشعار المجمع",
      validationError: "خطأ في التحقق",
      titleAndBodyRequired: "العنوان والرسالة مطلوبان",
      selectAtLeastOneUser: "يرجى اختيار مستخدم واحد على الأقل",

      // Permissions Management
      totalPermissions: "إجمالي الصلاحيات",
      activePermissions: "الصلاحيات النشطة", 
      inactivePermissions: "الصلاحيات غير النشطة",
      searchPermissions: "البحث في الصلاحيات...",
      allResources: "جميع الموارد",
      allActions: "جميع الإجراءات",
      permissionsLoadError: "فشل في تحميل الصلاحيات",
      permissionsEndpointNotAvailable: "نقطة نهاية الصلاحيات غير متاحة",
      noPermissions: "لا توجد صلاحيات",
      noPermissionsDescription: "لا توجد صلاحيات تطابق المرشحات الحالية.",
      createFirstPermission: "أنشئ صلاحيتك الأولى للبدء.",
      resource: "المورد",
      action: "الإجراء",
      permissionCreatedSuccessfully: "تم إنشاء الصلاحية بنجاح",
      permissionUpdatedSuccessfully: "تم تحديث الصلاحية بنجاح", 
      permissionDeletedSuccessfully: "تم حذف الصلاحية بنجاح",
      permissionStatusToggled: "تم تحديث حالة الصلاحية بنجاح",
      failedToCreatePermission: "فشل في إنشاء الصلاحية",
      failedToUpdatePermission: "فشل في تحديث الصلاحية",
      failedToDeletePermission: "فشل في حذف الصلاحية",
      failedToTogglePermissionStatus: "فشل في تغيير حالة الصلاحية",
      confirmDeletePermission: "هل أنت متأكد من أنك تريد حذف هذه الصلاحية؟",
      editPermission: "تعديل الصلاحية",
      editPermissionDescription: "تحديث تفاصيل وإعدادات الصلاحية.",
      createPermissionDescription: "إضافة صلاحية جديدة إلى النظام.",
      enterPermissionName: "أدخل اسم الصلاحية",
      enterPermissionDescription: "أدخل وصف الصلاحية",
      enterResource: "أدخل اسم المورد",
      enterAction: "أدخل اسم الإجراء",
      activePermission: "صلاحية نشطة",
      updatePermission: "تحديث الصلاحية",
      resourceRequired: "المورد مطلوب",
      actionRequired: "الإجراء مطلوب",
      
      // Role Permissions
      assignPermissions: "تعيين الصلاحيات",
      selectPermissions: "اختر الصلاحيات لهذا الدور",
      noPermissionsSelected: "لم يتم اختيار صلاحيات",
      permissionsSelected: "صلاحيات محددة",
      noPermissionsMatch: "لا توجد صلاحيات تطابق المرشحات",
      noRolesMatch: "لا توجد أدوار تطابق معايير البحث",
      totalRoles: "إجمالي الأدوار",
      activeRoles: "الأدوار النشطة", 
      inactiveRoles: "الأدوار غير النشطة",
      searchRoles: "البحث في الأدوار...",
      rolesLoadError: "فشل في تحميل الأدوار",
      rolesEndpointNotAvailable: "نقطة نهاية الأدوار غير متاحة. يرجى التأكد من تشغيل API الخلفي.",
      noRoles: "لا توجد أدوار",
      noRolesDescription: "لم يتم العثور على أدوار. قم بإنشاء أول دور للبدء.",
      createFirstRole: "إنشاء أول دور",
      roleCreatedSuccessfully: "تم إنشاء الدور بنجاح",
      roleUpdatedSuccessfully: "تم تحديث الدور بنجاح", 
      roleDeletedSuccessfully: "تم حذف الدور بنجاح",
      roleStatusToggled: "تم تحديث حالة الدور بنجاح",
      failedToCreateRole: "فشل في إنشاء الدور",
      failedToUpdateRole: "فشل في تحديث الدور",
      failedToDeleteRole: "فشل في حذف الدور",
      failedToToggleRoleStatus: "فشل في تحديث حالة الدور",
      confirmDeleteRole: "هل أنت متأكد من حذف الدور '{{name}}'؟ لا يمكن التراجع عن هذا الإجراء.",
      nameRequired: "الاسم مطلوب",
      deactivate: "إلغاء التفعيل",
      activate: "تفعيل",
      editRole: "تعديل الدور",
      editRoleDescription: "تحديث معلومات الدور والصلاحيات",
      createRoleDescription: "إنشاء دور جديد بصلاحيات محددة",
      enterRoleName: "أدخل اسم الدور",
      enterRoleDescription: "أدخل وصف الدور",
      activeRole: "دور نشط",
      updateRole: "تحديث الدور",
      
      validateCoupon: "التحقق من الكوبون",
      couponValidation: "التحقق من صحة الكوبون",
      orderAmount: "مبلغ الطلب",
      validate: "تحقق",
      finalAmount: "المبلغ النهائي",
      generateCode: "إنشاء كود",
      copyCode: "نسخ الكود",
      couponCreated: "تم إنشاء الكوبون بنجاح",
      couponUpdated: "تم تحديث الكوبون بنجاح",
      couponDeleted: "تم حذف الكوبون بنجاح",
      couponValidationSuccess: "الكوبون صالح",
      couponValidationError: "فشل في التحقق من الكوبون",
      confirmDeleteCoupon: "هل أنت متأكد من حذف هذا الكوبون؟",
      noCouponsFound: "لم يتم العثور على كوبونات",
      unlimited: "غير محدود",
      
      // ترجمات إضافية للكوبونات
      copiedToClipboard: "تم النسخ إلى الحافظة",
      couponFound: "كوبون موجود",
      couponsFound: "كوبونات موجودة",
      noCouponsMatch: "لا توجد كوبونات تطابق البحث",
      totalDiscountGiven: "إجمالي الخصم الممنوح",
      basicInformation: "المعلومات الأساسية",
      uniqueCode: "أدخل كود كوبون فريد",
      discountConfiguration: "إعدادات الخصم",
      selectDiscountType: "اختر نوع الخصم",
      amountInSAR: "المبلغ بالريال السعودي",
      minimumOrderAmount: "الحد الأدنى لمبلغ الطلب المطلوب",
      maximumDiscountAmount: "الحد الأقصى لمبلغ الخصم (للنسبة المئوية)",
      usageLimits: "حدود الاستخدام",
      totalNumberOfTimes: "العدد الإجمالي للمرات التي يمكن استخدام هذا الكوبون فيها",
      numberOfTimesEachUser: "عدد المرات التي يمكن لكل مستخدم استخدام هذا الكوبون",
      validityPeriod: "فترة الصلاحية",
      applicability: "القابلية للتطبيق",
      leaveEmptyForAllCities: "اتركه فارغاً للتطبيق على جميع المدن",
      leaveEmptyForAllVehicleTypes: "اتركه فارغاً للتطبيق على جميع أنواع المركبات",
      enableOrDisable: "تمكين أو تعطيل هذا الكوبون",
      updateCouponDetails: "تحديث تفاصيل وإعدادات الكوبون",
      createNewPromotional: "إنشاء كوبون خصم ترويجي جديد",
      detailedAnalytics: "تحليلات ورؤى مفصلة",
      selectDateRange: "اختر النطاق الزمني",
      last7Days: "آخر 7 أيام",
      last30Days: "آخر 30 يوم",
      last90Days: "آخر 90 يوم",
      lastYear: "العام الماضي",
      withoutCoupon: "بدون كوبون",
      withCoupon: "مع كوبون",
      revenueImpact: "تأثير الإيرادات",
      averageIncreasePerOrder: "متوسط الزيادة لكل طلب",
      dailyUsage: "اتجاهات الاستخدام اليومية",
      usage: "استخدامات",
      testValidationSystem: "اختبار نظام التحقق من الكوبونات",
      calculationBreakdown: "تفصيل الحساب",
      originalAmount: "المبلغ الأصلي",
      savings: "توفر",
      validationFailed: "فشل التحقق",
      noDiscountApplied: "لم يتم تطبيق خصم",
      sampleCoupons: "كوبونات عينة",
      useSampleCodes: "استخدم هذه الأكواد العينة لاختبار نظام التحقق",
      minOrder: "الحد الأدنى للطلب",
      maxDiscount: "الحد الأقصى للخصم",
      couponsExportedSuccessfully: "تم تصدير الكوبونات بنجاح",
      failedToExportCoupons: "فشل في تصدير الكوبونات",
      best: "الأفضل",

      // =========== الإشعارات ===========
      notificationsTitle: "إدارة الإشعارات",
      notificationsSubtitle: "إرسال إشعارات للنزلاء والموظفين",
      notificationsList: "قائمة الإشعارات",
      createNotification: "إنشاء إشعار",
      createNewNotification: "إنشاء إشعار جديد",
      notificationTitle: "عنوان الإشعار",
      notificationMessage: "رسالة الإشعار",
      selectType: "اختر النوع",
      targetAudience: "الجمهور المستهدف",
      selectTargetAudience: "اختر الجمهور المستهدف",
      allUsers: "جميع المستخدمين",
      allGuests: "جميع النزلاء",
      allStaff: "جميع الموظفين",
      specificProperty: "عقار محدد",
      specificUsers: "مستخدمين محددين",
      selectProperties: "اختر العقارات",
      selectSpecificUsers: "اختر مستخدمين محددين",
      pleaseSelectAtLeastOneProperty: "يرجى اختيار عقار واحد على الأقل",
      unknownTarget: "هدف غير معروف",
      scheduleFor: "جدولة لـ (اختياري)",
      sendNow: "إرسال الآن",
      scheduled: "مجدول",
      activeCities: "المدن النشطة",
      notificationCreated: "تم إنشاء الإشعار بنجاح",
      notificationCreatedSuccessfully: "تم إنشاء الإشعار بنجاح",
      notificationFailed: "فشل في إنشاء الإشعار",
      failedToCreateNotification: "فشل في إنشاء الإشعار",
      pleaseFillRequiredFields: "يرجى ملء جميع الحقول المطلوبة",
      pleaseSelectAtLeastOneCity: "يرجى اختيار مدينة واحدة على الأقل",
      pleaseSelectAtLeastOneUser: "يرجى اختيار مستخدم واحد على الأقل",
      
      // أنواع الإشعارات (خاصة بالفندق)
      notificationAnnouncement: "إعلان",
      notificationMaintenance: "صيانة",
      notificationHousekeeping: "التدبير المنزلي",
      notificationBooking: "حجز",
      notificationCheckin: "تسجيل الوصول",
      notificationCheckout: "تسجيل المغادرة",
      notificationPromo: "عرض ترويجي",
      notificationAlert: "تنبيه",

      // =========== الإعدادات ===========
      settingsTitle: "إعدادات النظام",
      settingsSubtitle: "إدارة إعدادات وتكوين النظام",
      generalSettings: "الإعدادات العامة",
      systemSettings: "إعدادات النظام",
      manageYourProfileInformation: "إدارة معلومات ملفك الشخصي والتفضيلات",
      profilePicture: "صورة الملف الشخصي",
      changePhoto: "تغيير الصورة",
      joined: "انضم في",
      profileDetails: "تفاصيل الملف الشخصي",
      enterFullName: "أدخل اسمك الكامل",
      enterEmail: "أدخل بريدك الإلكتروني",
      enterPhone: "أدخل رقم هاتفك",
      department: "القسم",
      enterDepartment: "أدخل قسمك",
      location: "الموقع",
      enterLocation: "أدخل موقعك",
      editProfile: "تعديل الملف الشخصي",
      profileUpdatedSuccessfully: "تم تحديث الملف الشخصي بنجاح",
      failedToUpdateProfile: "فشل في تحديث الملف الشخصي",
      languageSettings: "إعدادات اللغة",
      paymentSettings: "إعدادات الدفع",
      staffSettings: "إدارة الموظفين",
      
      // مصطلحات الجداول المشتركة
      entries: "إدخالات",
      
      first: "الأول",
      last: "الأخير",
      page: "صفحة",
      perPage: "لكل صفحة",
      searchPlaceholder: "بحث...",
      allFilters: "جميع المرشحات",
      
      
      // الإعدادات العامة
      platformSettings: "إعدادات المجموعة ",
      platformName: "اسم المجموعة ",
      enterPlatformName: "أدخل اسم المجموعة ",
      defaultCurrency: "العملة الافتراضية",
      selectCurrency: "اختر العملة",
      timezone: "المنطقة الزمنية",
      selectTimezone: "اختر المنطقة الزمنية",
      riyadhTime: "توقيت الرياض (UTC+3)",
      dubaiTime: "توقيت دبي (UTC+4)",
      gmt: "توقيت غرينتش (UTC+0)",
      est: "التوقيت الشرقي الأمريكي (UTC-5)",
      commissionRate: "معدل العمولة (%)",
      enterCommissionRate: "أدخل معدل العمولة",
      supportEmail: "بريد الدعم",
      enterSupportEmail: "أدخل بريد الدعم",
      maxTripDistance: "الحد الأقصى لمسافة الرحلة (كم)",
      enterMaxDistance: "أدخل الحد الأقصى للمسافة",
      supportPhone: "هاتف الدعم",
      enterSupportPhone: "أدخل هاتف الدعم",
      emergencyContact: "جهة الاتصال الطارئة",
      enterEmergencyContact: "أدخل جهة الاتصال الطارئة",
      saveSettings: "حفظ الإعدادات",
      settingsSaved: "تم حفظ الإعدادات بنجاح",
      
      // إعدادات العلامة التجارية
      brandingAppearance: "العلامة التجارية والمظهر",
      companyLogo: "رابط شعار الشركة",
      enterLogoUrl: "أدخل رابط الشعار",
      primaryBrandColor: "اللون الرئيسي للعلامة التجارية",
      hexColorCode: "كود اللون السادس عشري",
      companyDescription: "وصف الشركة",
      defaultCompanyDescription: "مجموعة  رائدة لمشاركة الرحلات تقدم خدمات نقل آمنة وموثوقة.",
      enterCompanyDescription: "أدخل وصف الشركة",
      favicon: "رابط أيقونة الموقع",
      enterFaviconUrl: "أدخل رابط أيقونة الموقع",
      secondaryBrandColor: "اللون الثانوي للعلامة التجارية",
      companyWebsite: "موقع الشركة الإلكتروني",
      enterWebsiteUrl: "أدخل رابط الموقع الإلكتروني",
      saveBranding: "حفظ العلامة التجارية",

      // إعدادات اللغة
      defaultLanguage: "اللغة الافتراضية",
      currentLanguage: "اللغة الحالية",
      languageChanged: "تم تغيير اللغة بنجاح",

      // إعدادات الدفع
      paymentGatewaySettings: "إعدادات بوابات الدفع",
      saudiPaymentCard: "شبكة المدفوعات السعودية",
      applePaymentService: "خدمة أبل باي",
      tapPaymentGateway: "بوابة تاب للدفع",
      buyNowPayLater: "خدمة اشتري الآن وادفع لاحقاً",
      neoLeapPayment: "حلول نيو ليب للدفع",
      moyasarPayment: "بوابة ميسر للدفع",
      apiKey: "مفتاح API",
      enterApiKey: "أدخل مفتاح API",
      certificate: "الشهادة",
      enterCertificate: "أدخل الشهادة",
      savePaymentSettings: "حفظ إعدادات الدفع",
      paymentSettingsSaved: "تم حفظ إعدادات الدفع بنجاح",

      // إعدادات الإشعارات
      notificationPreferences: "تفضيلات الإشعارات",
      emailNotificationsDesc: "استقبال الإشعارات عبر البريد الإلكتروني",
      smsNotificationsDesc: "استقبال الإشعارات عبر الرسائل النصية",
      newBooking: "حجز جديد",
      driverAssigned: "تم تعيين سائق",
      tripCompleted: "اكتملت الرحلة",
      systemAlerts: "تنبيهات النظام",
      saveNotificationSettings: "حفظ إعدادات الإشعارات",
      notificationSettingsSaved: "تم حفظ إعدادات الإشعارات بنجاح",

      // إدارة الموظفين
      adminUsersRoles: "المديرون والأدوار",
      addNewAdmin: "إضافة مدير جديد",
      addNewAdminUser: "إضافة مستخدم مدير جديد",
      name: "الاسم",
      fullName: "الاسم الكامل",
      email: "البريد الإلكتروني",
      securePassword: "كلمة مرور آمنة",
      role: "الدور",
      createAdmin: "إنشاء مدير",
      editAdminUser: "تعديل المستخدم المدير",
      updateAdmin: "تحديث المدير",
      noAdminUsers: "لا يوجد مديرون",
      getStartedByAddingAdmin: "ابدأ بإضافة مستخدم مدير.",
      
      // معلومات النظام
      applicationVersion: "إصدار التطبيق",
      databaseStatus: "حالة قاعدة البيانات",
      connected: "متصل",
      lastBackup: "آخر نسخة احتياطية",
      days: "أيام",
      hours: "ساعات",

      // =========== الدعم ===========
      supportTitle: "إدارة الدعم",
      supportSubtitle: "إدارة طلبات الدعم واستفسارات العملاء",
      supportTickets: "تذاكر الدعم",
      createTicket: "إنشاء تذكرة",
      ticketStatus: "حالة التذكرة",
      openTickets: "التذاكر المفتوحة",
      closedTickets: "التذاكر المغلقة",
      pendingTickets: "التذاكر المعلقة",
      assignedTo: "مخصص لـ",
      priority: "الأولوية",
      high: "عالية",
      medium: "متوسطة",
      low: "منخفضة",
      ticketDetails: "تفاصيل التذكرة",
      customerInfo: "معلومات العميل",
      issueDescription: "وصف المشكلة",
      resolution: "الحل",
      closeTicket: "إغلاق التذكرة",
      reopenTicket: "إعادة فتح التذكرة",
      assignTicket: "تخصيص التذكرة",
      addComment: "إضافة تعليق",
      supportComingSoon: "نظام الدعم قيد التطوير",
      featureUnderDevelopment: "هذه الميزة قيد التطوير",
      awaitingResponse: "في انتظار الرد",
      thisWeek: "هذا الأسبوع",
      
      // Media Management
      mediaManagement: "إدارة الوسائط",
      uploadAndManagePropertyMedia: "رفع وإدارة ملفات وسائط العقارات",
      selectPropertyForMedia: "اختر العقار لرفع الوسائط",
      uploadNewMedia: "رفع وسائط جديدة",
      existingMedia: "الوسائط الموجودة",
      noMediaFound: "لم يتم العثور على ملفات وسائط",
      altText: "النص البديل",
      title: "العنوان",
      description: "الوصف",
      setPrimaryImage: "تعيين كصورة أساسية",
      primary: "أساسي",
      enterAltText: "أدخل النص البديل لسهولة الوصول",
      enterTitle: "أدخل عنوان الوسائط",
      enterDescription: "أدخل وصف الوسائط",
      dropFilesHere: "اسحب الملفات هنا",
      orClickToSelect: "أو انقر للاختيار",
      selectFile: "اختر ملف",
      changeFile: "تغيير الملف",
      uploadMedia: "رفع الوسائط",
      uploading: "جاري الرفع...",
      reset: "إعادة تعيين",
      mediaUploadedSuccessfully: "تم رفع الوسائط بنجاح",
      failedToUploadMedia: "فشل في رفع الوسائط",
      mediaDeletedSuccessfully: "تم حذف الوسائط بنجاح",
      failedToDeleteMedia: "فشل في حذف الوسائط",
      confirmDeleteMedia: "هل أنت متأكد من حذف هذه الوسائط؟",
      invalidFileType: "نوع ملف غير صالح. يرجى اختيار ملف صورة أو فيديو",
      fileTooLarge: "حجم الملف يجب أن يكون أقل من 10 ميجابايت",
      pleaseSelectFile: "يرجى اختيار ملف للرفع",
      pleaseCompleteRequiredFields: "يرجى إكمال جميع الحقول المطلوبة",
      mediaEndpointNotAvailable: "إدارة الوسائط غير متاحة",
      mediaEndpointNotImplemented: "نقاط نهاية إدارة الوسائط لم يتم تنفيذها بعد على الخادم الخاص بك.",
      implementEndpoints: "يرجى تنفيذ نقاط النهاية التالية على الخادم الخلفي:",
      
      // User selection for notifications
      selectUsers: "اختيار المستخدمين",
      usersSelected: "مستخدم محدد",
      searchUsers: "البحث عن المستخدمين...",
      searchAndSelectUsersToSendNotifications: "البحث واختيار المستخدمين لإرسال الإشعارات إليهم"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;